import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @desc: 获取客户统计数据
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactStatReq, b: any) => Promise<quan.GetExtContactStatRsp>} TypeScript syntax */

export function GetExtContactStat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactStat",
    "auth": "1"
  }), o));
}
; // @desc: 获取代自建开发应用模板授权二维码
// @gen_to: customized_app
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetCustomizedTplAuthQrCodeReq, b: any) => Promise<quan.GetCustomizedTplAuthQrCodeRsp>} TypeScript syntax */

export function GetCustomizedTplAuthQrCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCustomizedTplAuthQrCode",
    "auth": "0"
  }), o));
}
; // @desc: 获取企业自建代开发应用
// @gen_to: customized_app

/** @type {(r: quan.GetCorpCustomizedAppListReq, b: any) => Promise<quan.GetCorpCustomizedAppListRsp>} TypeScript syntax */

export function GetCorpCustomizedAppList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpCustomizedAppList",
    "auth": "1"
  }), o));
}
; // @desc: 获取账号及分类关系
// @gen_to: account_category

/** @type {(r: quan.GetAccountCategoryReq, b: any) => Promise<quan.GetAccountCategoryRsp>} TypeScript syntax */

export function GetAccountCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAccountCategory",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// wework.ErrWwBizErr
// @freq: ip,3600,20
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetPreAuthCodeReq, b: any) => Promise<quan.GetPreAuthCodeRsp>} TypeScript syntax */

export function GetPreAuthCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetPreAuthCode",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrInvalidPermanentCode
// svr options: (ext.UserType) = account
// svr options: (ext.SkipPerm) = true

/** @type {(r: quan.HandleAuthReq, b: any) => Promise<quan.HandleAuthRsp>} TypeScript syntax */

export function HandleAuth(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/HandleAuth",
    "auth": "2"
  }), o));
}
; // @desc:
// @error:
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetScanLoginInfoReq, b: any) => Promise<quan.GetScanLoginInfoRsp>} TypeScript syntax */

export function GetScanLoginInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetScanLoginInfo",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrNotCorpStaff
// ErrInvalidCode
// svr options: (ext.UserType) = pub

/** @type {(r: quan.ScanLoginReq, b: any) => Promise<quan.ScanLoginRsp>} TypeScript syntax */

export function ScanLogin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ScanLogin",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrUnsupportedActiveState
// ErrUnsupportedAccountType 不支持的账号类型
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetUserListReq, b: any) => Promise<quan.GetUserListRsp>} TypeScript syntax */

export function GetUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrInvalidUserRole
// ErrNotPermitUpdateToCreator
// ErrNotPermitUpdateCreator
// ErrNotPermitUpdateSelfRole
// ErrInvalidOp

/** @type {(r: quan.OpUserReq, b: any) => Promise<quan.OpUserRsp>} TypeScript syntax */

export function OpUser(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/OpUser",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope

/** @type {(r: quan.StatUserCountByRoleReq, b: any) => Promise<quan.StatUserCountByRoleRsp>} TypeScript syntax */

export function StatUserCountByRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/StatUserCountByRole",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @freq: uid,300,20

/** @type {(r: quan.SyncContactsReq, b: any) => Promise<quan.SyncContactsRsp>} TypeScript syntax */

export function SyncContacts(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncContacts",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:

/** @type {(r: quan.GetAppScopeNotMatchUserCountReq, b: any) => Promise<quan.GetAppScopeNotMatchUserCountRsp>} TypeScript syntax */

export function GetAppScopeNotMatchUserCount(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAppScopeNotMatchUserCount",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUnsupportedAccountType 不支持的账号类型
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetExtContactFollowListReq, b: any) => Promise<quan.GetExtContactFollowListRsp>} TypeScript syntax */

export function GetExtContactFollowList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactFollowList",
    "auth": "1"
  }), o));
}
; // @desc: 选人控件专用
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetUserList4SelectorReq, b: any) => Promise<quan.GetUserList4SelectorRsp>} TypeScript syntax */

export function GetUserList4Selector(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserList4Selector",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrNotPermit

/** @type {(r: quan.GetExtContactReq, b: any) => Promise<quan.GetExtContactRsp>} TypeScript syntax */

export function GetExtContact(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContact",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpTagReachLimit 标签数量超过上限
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope

/** @type {(r: quan.SetCorpTagReq, b: any) => Promise<quan.SetCorpTagRsp>} TypeScript syntax */

export function SetCorpTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCorpTag",
    "auth": "1"
  }), o));
}
; // @desc: 操作日志列表
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen_to: oper_log

/** @type {(r: quan.GetOperLogListReq, b: any) => Promise<quan.GetOperLogListRsp>} TypeScript syntax */

export function GetOperLogList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetOperLogList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth

/** @type {(r: quan.BatchSetCorpTag2FollowReq, b: any) => Promise<quan.BatchSetCorpTag2FollowRsp>} TypeScript syntax */

export function BatchSetCorpTag2Follow(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetCorpTag2Follow",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope

/** @type {(r: quan.GetDupExtContactFollowListReq, b: any) => Promise<quan.GetDupExtContactFollowListRsp>} TypeScript syntax */

export function GetDupExtContactFollowList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDupExtContactFollowList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: user_attr

/** @type {(r: quan.GetUserAttrDefListReq, b: any) => Promise<quan.GetUserAttrDefListRsp>} TypeScript syntax */

export function GetUserAttrDefList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserAttrDefList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrUserAttrNameExisted
// @gen: t=add_model_db_proxy
// @gen_to: user_attr

/** @type {(r: quan.AddUserAttrDefReq, b: any) => Promise<quan.AddUserAttrDefRsp>} TypeScript syntax */

export function AddUserAttrDef(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddUserAttrDef",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrUserAttrDefNotFound
// @gen: t=del_model_db_proxy
// @gen_to: user_attr

/** @type {(r: quan.DelUserAttrDefReq, b: any) => Promise<quan.DelUserAttrDefRsp>} TypeScript syntax */

export function DelUserAttrDef(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelUserAttrDef",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrUserAttrNameExisted
// ErrUserAttrDefNotFound
// @gen: t=set_model_db_proxy
// @gen_to: user_attr

/** @type {(r: quan.SetUserAttrDefReq, b: any) => Promise<quan.SetUserAttrDefRsp>} TypeScript syntax */

export function SetUserAttrDef(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetUserAttrDef",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrUserAttrIdBothInEnableAndDisableList
// ErrUserAttrDefNotFound
// @gen_to: user_attr

/** @type {(r: quan.SetUserAttrDef4SysReq, b: any) => Promise<quan.SetUserAttrDef4SysRsp>} TypeScript syntax */

export function SetUserAttrDef4Sys(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetUserAttrDef4Sys",
    "auth": "1"
  }), o));
}
; // @desc: 设置当前成员指定客户的画像（自定义属性）
// @error:
// @gen_to: user_attr

/** @type {(r: quan.SetExtContactAttrReq, b: any) => Promise<quan.SetExtContactAttrRsp>} TypeScript syntax */

export function SetExtContactAttr(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetExtContactAttr",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: user_attr

/** @type {(r: quan.GetExtContactAttrReq, b: any) => Promise<quan.GetExtContactAttrRsp>} TypeScript syntax */

export function GetExtContactAttr(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactAttr",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrInvalidImageUrl 图片链接格式有问题
// ErrInvalidSchedulerTimeExceedSysSupport
// ErrInvalidSchedulerTimeAtPast
// ErrCorpTagNotFound
// ErrUserNotFound
// @gen: t=add_model_db_proxy
// @gen_to: msg
// svr options: (ext.EnableNonce) = true

/** @type {(r: quan.AddExtContactBatchSendReq, b: any) => Promise<quan.AddExtContactBatchSendRsp>} TypeScript syntax */

export function AddExtContactBatchSend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddExtContactBatchSend",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy
// @gen_to: msg

/** @type {(r: quan.GetExtContactBatchSendReq, b: any) => Promise<quan.GetExtContactBatchSendRsp>} TypeScript syntax */

export function GetExtContactBatchSend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactBatchSend",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=get_model_list_db_proxy
// @gen_to: msg

/** @type {(r: quan.GetExtContactBatchSendListReq, b: any) => Promise<quan.GetExtContactBatchSendListRsp>} TypeScript syntax */

export function GetExtContactBatchSendList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactBatchSendList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrCorpTagNotFound
// ErrUserNotFound
// @gen_to: msg

/** @type {(r: quan.CountExtContactBatchSendReq, b: any) => Promise<quan.CountExtContactBatchSendRsp>} TypeScript syntax */

export function CountExtContactBatchSend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CountExtContactBatchSend",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @freq: uid,300,20

/** @type {(r: quan.SyncExtContactReq, b: any) => Promise<quan.SyncExtContactRsp>} TypeScript syntax */

export function SyncExtContact(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncExtContact",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrSidebarTabNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: ext_contact
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetExtContactEventTimelineListReq, b: any) => Promise<quan.GetExtContactEventTimelineListRsp>} TypeScript syntax */

export function GetExtContactEventTimelineList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactEventTimelineList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInDataScope 没有操作该成员数据的权限，操作失败
// ErrUserRoleNotFound 员工不在任何管理组内
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrNotPermit
// @gen_to: ext_contact

/** @type {(r: quan.AddExtContactEventReq, b: any) => Promise<quan.AddExtContactEventRsp>} TypeScript syntax */

export function AddExtContactEvent(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddExtContactEvent",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrNotPermit
// @gen_to: ext_contact

/** @type {(r: quan.DelExtContactEventReq, b: any) => Promise<quan.DelExtContactEventRsp>} TypeScript syntax */

export function DelExtContactEvent(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelExtContactEvent",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen_to: msg
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetExtContactBatchSendStaffListReq, b: any) => Promise<quan.GetExtContactBatchSendStaffListRsp>} TypeScript syntax */

export function GetExtContactBatchSendStaffList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactBatchSendStaffList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: msg
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetExtContactBatchSendExtListReq, b: any) => Promise<quan.GetExtContactBatchSendExtListRsp>} TypeScript syntax */

export function GetExtContactBatchSendExtList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactBatchSendExtList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrInvalidImageUrl 图片链接格式有问题
// ErrInvalidSchedulerTimeExceedSysSupport
// ErrInvalidSchedulerTimeAtPast
// ErrCorpTagNotFound
// ErrUserNotFound
// ErrExtContactBatchSendNotPermitEdit
// @gen: t=set_model_db_proxy
// @gen_to: msg
// svr options: (ext.EnableNonce) = true

/** @type {(r: quan.SetExtContactBatchSendReq, b: any) => Promise<quan.SetExtContactBatchSendRsp>} TypeScript syntax */

export function SetExtContactBatchSend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetExtContactBatchSend",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: msg

/** @type {(r: quan.NotifyStaffExtContactBatchSendReq, b: any) => Promise<quan.NotifyStaffExtContactBatchSendRsp>} TypeScript syntax */

export function NotifyStaffExtContactBatchSend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/NotifyStaffExtContactBatchSend",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrGetWxAdminLoginQrUrlFailed
// @gen_to: auth_conf
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetWxAdminLoginQrUrlReq, b: any) => Promise<quan.GetWxAdminLoginQrUrlRsp>} TypeScript syntax */

export function GetWxAdminLoginQrUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWxAdminLoginQrUrl",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrWxAdminSelectCorp2LoginFailed
// ErrMissWwCorpId 请选择要授权安装的企业微信
// ErrUserDoesNotTheWxAdmin
// ErrMissOpenId 请扫公众号二维码进行登录
// ErrGetWxAdminLoginStateFailed
// @gen_to: auth_conf
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetWxAdminLoginStateReq, b: any) => Promise<quan.GetWxAdminLoginStateRsp>} TypeScript syntax */

export function GetWxAdminLoginState(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWxAdminLoginState",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrWxAdminNotLogin
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetDeptListReq, b: any) => Promise<quan.GetDeptListRsp>} TypeScript syntax */

export function GetDeptList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDeptList",
    "auth": "2"
  }), o));
}
; // @desc:
// @error:
// ErrWxAdminNotLogin
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetDeptUserListReq, b: any) => Promise<quan.GetDeptUserListRsp>} TypeScript syntax */

export function GetDeptUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDeptUserList",
    "auth": "2"
  }), o));
}
; // @desc:
// @error:
// ErrWxAdminNotLogin
// ErrMissWwCorpId 请选择要授权安装的企业微信
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.SetCorpVisibleScopeReq, b: any) => Promise<quan.SetCorpVisibleScopeRsp>} TypeScript syntax */

export function SetCorpVisibleScope(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCorpVisibleScope",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// wework.ErrWxNonAuthAppAgentIdNoPerm 自建应用无法同步员工
// wework.ErrWxNonAuthAppCallbackNotSet 可调用应用列表中的自建应用没有勾选
// wework.ErrWwBizErr
// @gen: t=get_model_list_db_proxy
// @gen_to: chat

/** @type {(r: quan.GetGroupChatListReq, b: any) => Promise<quan.GetGroupChatListRsp>} TypeScript syntax */

export function GetGroupChatList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetGroupChatList",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: chat

/** @type {(r: quan.ExportGroupChatListReq, b: any) => Promise<quan.ExportGroupChatListRsp>} TypeScript syntax */

export function ExportGroupChatList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportGroupChatList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// wework.ErrWwBizErr
// @gen: t=get_model_db_proxy
// @gen_to: chat

/** @type {(r: quan.GetGroupChatReq, b: any) => Promise<quan.GetGroupChatRsp>} TypeScript syntax */

export function GetGroupChat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetGroupChat",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactGroupChatListReq, b: any) => Promise<quan.GetExtContactGroupChatListRsp>} TypeScript syntax */

export function GetExtContactGroupChatList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactGroupChatList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrNotPermit
// @gen_to: ext_contact

/** @type {(r: quan.SetExtContactEventReq, b: any) => Promise<quan.SetExtContactEventRsp>} TypeScript syntax */

export function SetExtContactEvent(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetExtContactEvent",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrGroupChatNotFound
// @gen_to: chat
// @freq: uid,300,20

/** @type {(r: quan.SyncGroupChatReq, b: any) => Promise<quan.SyncGroupChatRsp>} TypeScript syntax */

export function SyncGroupChat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncGroupChat",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUnsupportedAccountType 不支持的账号类型
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: chat

/** @type {(r: quan.GetGroupChatOwnerListReq, b: any) => Promise<quan.GetGroupChatOwnerListRsp>} TypeScript syntax */

export function GetGroupChatOwnerList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetGroupChatOwnerList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=add_model_db_proxy
// @gen_to: channel

/** @type {(r: quan.AddChannelReq, b: any) => Promise<quan.AddChannelRsp>} TypeScript syntax */

export function AddChannel(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddChannel",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInDataScope 没有操作该成员数据的权限，操作失败
// ErrUserRoleNotFound 员工不在任何管理组内
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=set_model_db_proxy
// @gen_to: channel

/** @type {(r: quan.SetChannelReq, b: any) => Promise<quan.SetChannelRsp>} TypeScript syntax */

export function SetChannel(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetChannel",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: channel

/** @type {(r: quan.GetChannelListReq, b: any) => Promise<quan.GetChannelListRsp>} TypeScript syntax */

export function GetChannelList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannelList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy
// @gen_to: channel

/** @type {(r: quan.GetChannelReq, b: any) => Promise<quan.GetChannelRsp>} TypeScript syntax */

export function GetChannel(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannel",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotActive 选择了未激活企业微信或未实名认证的成员，操作失败
// ErrAppScopeForbidden 应用无权限，请检查配置
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrUserNotInAppScope
// @gen: t=add_model_db_proxy
// @gen_to: live_code

/** @type {(r: quan.AddChannelLiveCodeReq, b: any) => Promise<quan.AddChannelLiveCodeRsp>} TypeScript syntax */

export function AddChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotActive 选择了未激活企业微信或未实名认证的成员，操作失败
// ErrAppScopeForbidden 应用无权限，请检查配置
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrUserNotInAppScope
// @gen: t=set_model_db_proxy
// @gen_to: live_code

/** @type {(r: quan.SetChannelLiveCodeReq, b: any) => Promise<quan.SetChannelLiveCodeRsp>} TypeScript syntax */

export function SetChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotActive 选择了未激活企业微信或未实名认证的成员，操作失败
// ErrAppScopeForbidden 应用无权限，请检查配置
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrUserNotInAppScope
// @gen: t=set_model_db_proxy
// @gen_to: live_code

/** @type {(r: quan.BatchSetWelcomeMsg4ChannelLiveCodeReq, b: any) => Promise<quan.BatchSetWelcomeMsg4ChannelLiveCodeRsp>} TypeScript syntax */

export function BatchSetWelcomeMsg4ChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetWelcomeMsg4ChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=set_model_db_proxy
// @gen_to: live_code

/** @type {(r: quan.CountBatchSetWelcomeMsg4ChannelLiveCodeReq, b: any) => Promise<quan.CountBatchSetWelcomeMsg4ChannelLiveCodeRsp>} TypeScript syntax */

export function CountBatchSetWelcomeMsg4ChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CountBatchSetWelcomeMsg4ChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=del_model_db_proxy
// @gen_to: live_code

/** @type {(r: quan.DelChannelLiveCodeReq, b: any) => Promise<quan.DelChannelLiveCodeRsp>} TypeScript syntax */

export function DelChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: live_code

/** @type {(r: quan.GetChannelLiveCodeListReq, b: any) => Promise<quan.GetChannelLiveCodeListRsp>} TypeScript syntax */

export function GetChannelLiveCodeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannelLiveCodeList",
    "auth": "1"
  }), o));
}
; // @gen_to: channel_live_code_import

/** @type {(r: quan.CheckExcel4ChannelLiveCodeReq, b: any) => Promise<quan.CheckExcel4ChannelLiveCodeRsp>} TypeScript syntax */

export function CheckExcel4ChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckExcel4ChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @gen_to: channel_live_code_import

/** @type {(r: quan.ImportChannelLiveCodeReq, b: any) => Promise<quan.ImportChannelLiveCodeRsp>} TypeScript syntax */

export function ImportChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ImportChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy
// @gen_to: live_code

/** @type {(r: quan.GetChannelLiveCodeReq, b: any) => Promise<quan.GetChannelLiveCodeRsp>} TypeScript syntax */

export function GetChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: msg

/** @type {(r: quan.GetExtContactBatchSendGroupListReq, b: any) => Promise<quan.GetExtContactBatchSendGroupListRsp>} TypeScript syntax */

export function GetExtContactBatchSendGroupList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactBatchSendGroupList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrInvalidImageUrl 图片链接格式有问题
// ErrInvalidSchedulerTimeExceedSysSupport
// ErrInvalidSchedulerTimeAtPast
// ErrCorpTagNotFound
// ErrUserNotFound
// ErrAvailableGroupMemberNotEnough
// @gen: t=add_model_db_proxy
// @gen_to: invite

/** @type {(r: quan.AddInviteGroupByTagReq, b: any) => Promise<quan.AddInviteGroupByTagRsp>} TypeScript syntax */

export function AddInviteGroupByTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddInviteGroupByTag",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=del_model_db_proxy
// @gen_to: invite

/** @type {(r: quan.DelInviteGroupByTagReq, b: any) => Promise<quan.DelInviteGroupByTagRsp>} TypeScript syntax */

export function DelInviteGroupByTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelInviteGroupByTag",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=get_model_db_proxy
// @gen_to: invite

/** @type {(r: quan.GetInviteGroupByTagReq, b: any) => Promise<quan.GetInviteGroupByTagRsp>} TypeScript syntax */

export function GetInviteGroupByTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInviteGroupByTag",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserRoleNotFound 员工不在任何管理组内
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: invite

/** @type {(r: quan.GetInviteGroupByTagListReq, b: any) => Promise<quan.GetInviteGroupByTagListRsp>} TypeScript syntax */

export function GetInviteGroupByTagList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInviteGroupByTagList",
    "auth": "1"
  }), o));
}
; // @desc: 用户首次注册 or 登录
// @error:
// wechat.ErrUnknownAuthType 未知的authType
// wechat.ErrWechat 系统错误
// @gen_to: apply
// @freq: ip,3600,20
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetAuthRegisterQrReq, b: any) => Promise<quan.GetAuthRegisterQrRsp>} TypeScript syntax */

export function GetAuthRegisterQr(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAuthRegisterQr",
    "auth": "0"
  }), o));
}
; // @desc: 验证用户是否登录成功
// @error:
// ErrMissOpenId 请扫公众号二维码进行登录
// @gen_to: apply
// svr options: (ext.UserType) = pub

/** @type {(r: quan.CheckAuthRegisterQrReq, b: any) => Promise<quan.CheckAuthRegisterQrRsp>} TypeScript syntax */

export function CheckAuthRegisterQr(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckAuthRegisterQr",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrExtContactBatchSendNotPermitEdit
// @gen_to: msg

/** @type {(r: quan.CancelExtContactBatchSendReq, b: any) => Promise<quan.CancelExtContactBatchSendRsp>} TypeScript syntax */

export function CancelExtContactBatchSend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CancelExtContactBatchSend",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=get_model_db_proxy
// @gen_to: user_attr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetSysUserAttrDefReq, b: any) => Promise<quan.GetSysUserAttrDefRsp>} TypeScript syntax */

export function GetSysUserAttrDef(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSysUserAttrDef",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: user_attr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetSysUserAttrDefListReq, b: any) => Promise<quan.GetSysUserAttrDefListRsp>} TypeScript syntax */

export function GetSysUserAttrDefList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSysUserAttrDefList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=add_model_db_proxy
// @gen_to: user_attr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddSysUserAttrDefReq, b: any) => Promise<quan.AddSysUserAttrDefRsp>} TypeScript syntax */

export function AddSysUserAttrDef(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddSysUserAttrDef",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=set_model_db_proxy
// @gen_to: user_attr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetSysUserAttrDefReq, b: any) => Promise<quan.SetSysUserAttrDefRsp>} TypeScript syntax */

export function SetSysUserAttrDef(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetSysUserAttrDef",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=del_model_db_proxy
// @gen_to: user_attr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelSysUserAttrDefReq, b: any) => Promise<quan.DelSysUserAttrDefRsp>} TypeScript syntax */

export function DelSysUserAttrDef(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelSysUserAttrDef",
    "auth": "1"
  }), o));
}
; // @desc: GET 请求，要带参 url=<url>
// @error:
// @gen_to: utils
// svr options: (ext.UserType) = pub

/** @type {(r: quan.DownloadResourceReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function DownloadResource(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DownloadResource",
    "auth": "0"
  }), o));
}
; // @name: 检查圈量 安装情况
// @desc:
// @error:
// ErrMissOpenId 请扫公众号二维码进行登录
// @gen_to: apply
// svr options: (ext.UserType) = pub

/** @type {(r: quan.CheckInstallStepReq, b: any) => Promise<quan.CheckInstallStepRsp>} TypeScript syntax */

export function CheckInstallStep(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckInstallStep",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrMissOpenId 请扫公众号二维码进行登录
// @gen: t=add_model_db_proxy
// @gen_to: apply
// svr options: (ext.UserType) = pub

/** @type {(r: quan.AddApplyInstallReq, b: any) => Promise<quan.AddApplyInstallRsp>} TypeScript syntax */

export function AddApplyInstall(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddApplyInstall",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// @gen: t=get_model_db_proxy
// @gen_to: apply
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetApplyInstallAdminReq, b: any) => Promise<quan.GetApplyInstallAdminRsp>} TypeScript syntax */

export function GetApplyInstallAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetApplyInstallAdmin",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: apply
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetApplyInstallListAdminReq, b: any) => Promise<quan.GetApplyInstallListAdminRsp>} TypeScript syntax */

export function GetApplyInstallListAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetApplyInstallListAdmin",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ossapi.ErrInvalidStrId
// notify.ErrInvalidSmsTemplate
// notify.ErrSmsTencentCloudServerFail 调用腾讯云的sms服务失败
// notify.ErrLimitControl 超过了短信发送频率.
// notify.ErrSmsAliyunConnectionFail 阿里云的sms服务连接失败
// notify.ErrSmsSendReceiverDailyLimit 当日用户以超过接收短信次数
// ossapi.ErrGtMaxFrequency
// notify.ErrSmsConfigNotFound 找不到sms的配置
// notify.ErrSmsAliyunServerFail 调用阿里云的sms服务失败
// notify.ErrSmsSendTemplateDailyLimit 当日已超过模版使用次数
// @gen: t=set_model_db_proxy
// @gen_to: apply
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetApplyInstallAdminReq, b: any) => Promise<quan.SetApplyInstallAdminRsp>} TypeScript syntax */

export function SetApplyInstallAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetApplyInstallAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen_to: invite

/** @type {(r: quan.CountInviteGroupByTagReq, b: any) => Promise<quan.CountInviteGroupByTagRsp>} TypeScript syntax */

export function CountInviteGroupByTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CountInviteGroupByTag",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrUserInstallAppIncomplete 您的企业微信账号缺少配置客户联系的权限，请联系超级管理员授权安装
// ErrAppNotFound
// ErrUserInstallAppNotPermit 您的企业微信账号缺少安装应用的权限，请联系超级管理员授权安装
// ErrHttpRequestError 网络异常，请重试
// ErrInstallFailed
// ErrWxAdminEditableContactApp 开启企业通讯录可编辑权限失败
// qrobot.ErrGetWxContactAppInfoFailed 获取企业微信通讯录信息失败
// ErrMissOpenId 请扫公众号二维码进行登录
// ErrMissWwCorpId 请选择要授权安装的企业微信
// ErrWxAdminNotLogin
// ErrGetDeptListFailed
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.InitNonAuthAppReq, b: any) => Promise<quan.InitNonAuthAppRsp>} TypeScript syntax */

export function InitNonAuthApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/InitNonAuthApp",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetSystemConfigReq, b: any) => Promise<quan.SetSystemConfigRsp>} TypeScript syntax */

export function SetSystemConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetSystemConfig",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetSystemConfigReq, b: any) => Promise<quan.GetSystemConfigRsp>} TypeScript syntax */

export function GetSystemConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSystemConfig",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy
// @gen_to: welcome

/** @type {(r: quan.GetWelcomeMsgReq, b: any) => Promise<quan.GetWelcomeMsgRsp>} TypeScript syntax */

export function GetWelcomeMsg(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWelcomeMsg",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrInvalidLink 链接传参有问题
// ErrInvalidImageUrl 图片链接格式有问题
// ErrInvalidMiniProgram
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=set_model_db_proxy
// @gen_to: welcome

/** @type {(r: quan.SetWelcomeMsgReq, b: any) => Promise<quan.SetWelcomeMsgRsp>} TypeScript syntax */

export function SetWelcomeMsg(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetWelcomeMsg",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrInvalidMiniProgram
// ErrInvalidLink 链接传参有问题
// ErrInvalidImageUrl 图片链接格式有问题
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=add_model_db_proxy
// @gen_to: welcome

/** @type {(r: quan.AddWelcomeMsgReq, b: any) => Promise<quan.AddWelcomeMsgRsp>} TypeScript syntax */

export function AddWelcomeMsg(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddWelcomeMsg",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: welcome

/** @type {(r: quan.GetWelcomeMsgListReq, b: any) => Promise<quan.GetWelcomeMsgListRsp>} TypeScript syntax */

export function GetWelcomeMsgList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWelcomeMsgList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=del_model_db_proxy
// @gen_to: welcome

/** @type {(r: quan.DelWelcomeMsgReq, b: any) => Promise<quan.DelWelcomeMsgRsp>} TypeScript syntax */

export function DelWelcomeMsg(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelWelcomeMsg",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy
// @gen_to: config

/** @type {(r: quan.GetInstallConfigReq, b: any) => Promise<quan.GetInstallConfigRsp>} TypeScript syntax */

export function GetInstallConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInstallConfig",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrAppNotFound
// @gen: t=set_model_db_proxy
// @gen_to: config

/** @type {(r: quan.SetInstallConfigReq, b: any) => Promise<quan.SetInstallConfigRsp>} TypeScript syntax */

export function SetInstallConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetInstallConfig",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen_to: login
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetWebLoginInfoReq, b: any) => Promise<quan.GetWebLoginInfoRsp>} TypeScript syntax */

export function GetWebLoginInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWebLoginInfo",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrUserLoginNotDistribute 用户没有被授权
// ErrCorpVersionExpire 企业版本已过期
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrNotCorpStaff
// ErrInvalidCode
// @gen_to: login
// svr options: (ext.UserType) = pub

/** @type {(r: quan.WebLoginReq, b: any) => Promise<quan.WebLoginRsp>} TypeScript syntax */

export function WebLogin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/WebLogin",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=add_model_db_proxy
// @gen_to: feedback
// @freq: ip,300,10

/** @type {(r: quan.AddUserFeedbackReq, b: any) => Promise<quan.AddUserFeedbackRsp>} TypeScript syntax */

export function AddUserFeedback(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddUserFeedback",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: feedback
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetUserFeedbackListReq, b: any) => Promise<quan.GetUserFeedbackListRsp>} TypeScript syntax */

export function GetUserFeedbackList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserFeedbackList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrMissTaskId 没有找到对应的异步任务
// ErrMissWwCorpId 请选择要授权安装的企业微信
// @gen_to: apply
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetAsyncTaskStateReq, b: any) => Promise<quan.GetAsyncTaskStateRsp>} TypeScript syntax */

export function GetAsyncTaskState(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAsyncTaskState",
    "auth": "2"
  }), o));
}
; // @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: help_doc

/** @type {(r: quan.GetHelpDocListReq, b: any) => Promise<quan.GetHelpDocListRsp>} TypeScript syntax */

export function GetHelpDocList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetHelpDocList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrCorpTagNameDup
// ErrInvalidTagNameLen
// ErrCorpTagNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: tag

/** @type {(r: quan.SetCorpTag2FollowReq, b: any) => Promise<quan.SetCorpTag2FollowRsp>} TypeScript syntax */

export function SetCorpTag2Follow(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCorpTag2Follow",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=add_model_db_proxy
// @gen_to: help_doc
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddHelpDocReq, b: any) => Promise<quan.AddHelpDocRsp>} TypeScript syntax */

export function AddHelpDoc(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddHelpDoc",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=set_model_db_proxy
// @gen_to: help_doc
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetHelpDocReq, b: any) => Promise<quan.SetHelpDocRsp>} TypeScript syntax */

export function SetHelpDoc(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetHelpDoc",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=del_model_db_proxy
// @gen_to: help_doc
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelHelpDocReq, b: any) => Promise<quan.DelHelpDocRsp>} TypeScript syntax */

export function DelHelpDoc(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelHelpDoc",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=add_model_db_proxy
// @gen_to: change_log
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddChangeLogReq, b: any) => Promise<quan.AddChangeLogRsp>} TypeScript syntax */

export function AddChangeLog(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddChangeLog",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen: t=del_model_db_proxy
// @gen_to: change_log
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelChangeLogReq, b: any) => Promise<quan.DelChangeLogRsp>} TypeScript syntax */

export function DelChangeLog(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelChangeLog",
    "auth": "1"
  }), o));
}
; // @gen_to: change_log
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetChangeLogReq, b: any) => Promise<quan.SetChangeLogRsp>} TypeScript syntax */

export function SetChangeLog(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetChangeLog",
    "auth": "1"
  }), o));
}
; // @gen_to: change_log

/** @type {(r: quan.GetChangeLogListReq, b: any) => Promise<quan.GetChangeLogListRsp>} TypeScript syntax */

export function GetChangeLogList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChangeLogList",
    "auth": "1"
  }), o));
}
; // @desc: 获取引导图
// @error:
// @gen_to: config
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetGuidePicReq, b: any) => Promise<quan.GetGuidePicRsp>} TypeScript syntax */

export function GetGuidePic(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetGuidePic",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCreatorNotFound
// ErrCorpNotAuth

/** @type {(r: quan.GetCorpInfoReq, b: any) => Promise<quan.GetCorpInfoRsp>} TypeScript syntax */

export function GetCorpInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: help_doc
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetHelpDocListStaffReq, b: any) => Promise<quan.GetHelpDocListStaffRsp>} TypeScript syntax */

export function GetHelpDocListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetHelpDocListStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: change_log
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetChangeLogListStaffReq, b: any) => Promise<quan.GetChangeLogListStaffRsp>} TypeScript syntax */

export function GetChangeLogListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChangeLogListStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope

/** @type {(r: quan.GetCorpStatReq, b: any) => Promise<quan.GetCorpStatRsp>} TypeScript syntax */

export function GetCorpStat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpStat",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 发送验证码
// @desc: pub 的 userType 前端默认不带登录态，如果验证逻辑在登录后，发送时可以提醒前端带上
// 问题的关键是验证码缓存 key 含有 corp_id
// @error:
// notify.ErrSmsConfigNotFound 找不到sms的配置
// notify.ErrInvalidSmsTemplate
// notify.ErrLimitControl 超过了短信发送频率.
// notify.ErrSmsAliyunServerFail 调用阿里云的sms服务失败
// notify.ErrSmsAliyunConnectionFail 阿里云的sms服务连接失败
// ossapi.ErrGtMaxFrequency
// ossapi.ErrInvalidStrId
// verifycode.ErrSendInterval 验证码发送频繁，请稍后再试
// notify.ErrSmsTencentCloudServerFail 调用腾讯云的sms服务失败
// notify.ErrSmsSendReceiverDailyLimit 当日用户以超过接收短信次数
// notify.ErrSmsSendTemplateDailyLimit 当日已超过模版使用次数
// svr options: (ext.UserType) = pub

/** @type {(r: quan.SendVerifyCodeReq, b: any) => Promise<quan.SendVerifyCodeRsp>} TypeScript syntax */

export function SendVerifyCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SendVerifyCode",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// ErrUnsupportedAccountType 不支持的账号类型
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: export

/** @type {(r: quan.ExportExtContactFollowListReq, b: any) => Promise<quan.ExportExtContactFollowListRsp>} TypeScript syntax */

export function ExportExtContactFollowList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportExtContactFollowList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetAuditConfigReq, b: any) => Promise<quan.GetAuditConfigRsp>} TypeScript syntax */

export function GetAuditConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAuditConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetAuditConfigReq, b: any) => Promise<quan.SetAuditConfigRsp>} TypeScript syntax */

export function SetAuditConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetAuditConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetContactUsConfigReq, b: any) => Promise<quan.GetContactUsConfigRsp>} TypeScript syntax */

export function GetContactUsConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetContactUsConfig",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetContactUsConfigReq, b: any) => Promise<quan.SetContactUsConfigRsp>} TypeScript syntax */

export function SetContactUsConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetContactUsConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: config

/** @type {(r: quan.GetCommonlyUsedModuleConfigReq, b: any) => Promise<quan.GetCommonlyUsedModuleConfigRsp>} TypeScript syntax */

export function GetCommonlyUsedModuleConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCommonlyUsedModuleConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetCommonlyUsedModuleConfigReq, b: any) => Promise<quan.SetCommonlyUsedModuleConfigRsp>} TypeScript syntax */

export function SetCommonlyUsedModuleConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCommonlyUsedModuleConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetWxAdminAuthBizCorpIdListReq, b: any) => Promise<quan.GetWxAdminAuthBizCorpIdListRsp>} TypeScript syntax */

export function GetWxAdminAuthBizCorpIdList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWxAdminAuthBizCorpIdList",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=add_model_db_proxy
// @freq: ip,3600,10
// @gen_to: customized_customer_clue
// svr options: (ext.UserType) = pub

/** @type {(r: quan.AddCustomizedCustomerClueReq, b: any) => Promise<quan.AddCustomizedCustomerClueRsp>} TypeScript syntax */

export function AddCustomizedCustomerClue(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddCustomizedCustomerClue",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: customized_customer_clue
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCustomizedCustomerClueListReq, b: any) => Promise<quan.GetCustomizedCustomerClueListRsp>} TypeScript syntax */

export function GetCustomizedCustomerClueList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCustomizedCustomerClueList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=update_model_db_proxy
// @gen_to: customized_customer_clue
// svr options: (ext.UserType) = staff

/** @type {(r: quan.UpdateCustomizedCustomerClueReq, b: any) => Promise<quan.UpdateCustomizedCustomerClueRsp>} TypeScript syntax */

export function UpdateCustomizedCustomerClue(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateCustomizedCustomerClue",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCommonlyUsedModuleConfigStaffReq, b: any) => Promise<quan.GetCommonlyUsedModuleConfigStaffRsp>} TypeScript syntax */

export function GetCommonlyUsedModuleConfigStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCommonlyUsedModuleConfigStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: apply

/** @type {(r: quan.InitAutoInstallAppReq, b: any) => Promise<quan.InitAutoInstallAppRsp>} TypeScript syntax */

export function InitAutoInstallApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/InitAutoInstallApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// svr options: (ext.UserType) = pub

/** @type {(r: quan.StaffLoginBySsoCodeReq, b: any) => Promise<quan.StaffLoginBySsoCodeRsp>} TypeScript syntax */

export function StaffLoginBySsoCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/StaffLoginBySsoCode",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: apply
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCorpApplyAuditConfigReq, b: any) => Promise<quan.GetCorpApplyAuditConfigRsp>} TypeScript syntax */

export function GetCorpApplyAuditConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpApplyAuditConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: apply
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetCorpApplyAuditConfigReq, b: any) => Promise<quan.SetCorpApplyAuditConfigRsp>} TypeScript syntax */

export function SetCorpApplyAuditConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCorpApplyAuditConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope

/** @type {(r: quan.GetUserInfoReq, b: any) => Promise<quan.GetUserInfoRsp>} TypeScript syntax */

export function GetUserInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope

/** @type {(r: quan.SyncDataAfterConfigWwAppReq, b: any) => Promise<quan.SyncDataAfterConfigWwAppRsp>} TypeScript syntax */

export function SyncDataAfterConfigWwApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncDataAfterConfigWwApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// wechat.ErrAccessTokenNotFound
// wechat.ErrWechat 系统错误
// wechat.ErrNotOfficialApp 非公众号
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetJsConfigReq, b: any) => Promise<quan.GetJsConfigRsp>} TypeScript syntax */

export function GetJsConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetJsConfig",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config

/** @type {(r: quan.SetOfficialAccountConfigReq, b: any) => Promise<quan.SetOfficialAccountConfigRsp>} TypeScript syntax */

export function SetOfficialAccountConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetOfficialAccountConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config

/** @type {(r: quan.GetOfficialAccountConfigReq, b: any) => Promise<quan.GetOfficialAccountConfigRsp>} TypeScript syntax */

export function GetOfficialAccountConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetOfficialAccountConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: apply
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetApplyInstallReq, b: any) => Promise<quan.GetApplyInstallRsp>} TypeScript syntax */

export function GetApplyInstall(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetApplyInstall",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMissOpenId 请扫公众号二维码进行登录
// ErrWxAdminNotLogin
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetDeptAndUserListReq, b: any) => Promise<quan.GetDeptAndUserListRsp>} TypeScript syntax */

export function GetDeptAndUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDeptAndUserList",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrWxAdminNotLogin
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetDeptAndUserListStateReq, b: any) => Promise<quan.GetDeptAndUserListStateRsp>} TypeScript syntax */

export function GetDeptAndUserListState(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDeptAndUserListState",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMaterialCategoryNameExisted
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=add_model_db_proxy
// @gen_to: material

/** @type {(r: quan.AddMaterialCategoryReq, b: any) => Promise<quan.AddMaterialCategoryRsp>} TypeScript syntax */

export function AddMaterialCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddMaterialCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=add_model_db_proxy
// @gen_to: material.go

/** @type {(r: quan.AddMaterialReq, b: any) => Promise<quan.AddMaterialRsp>} TypeScript syntax */

export function AddMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrNotPermit
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=set_model_db_proxy
// @gen_to: material.go

/** @type {(r: quan.SetMaterialReq, b: any) => Promise<quan.SetMaterialRsp>} TypeScript syntax */

export function SetMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy
// @gen_to: material.go

/** @type {(r: quan.GetMaterialReq, b: any) => Promise<quan.GetMaterialRsp>} TypeScript syntax */

export function GetMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: material.go

/** @type {(r: quan.GetMaterialListReq, b: any) => Promise<quan.GetMaterialListRsp>} TypeScript syntax */

export function GetMaterialList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMaterialList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrNotPermit
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=del_model_db_proxy
// @gen_to: material.go

/** @type {(r: quan.DelMaterialReq, b: any) => Promise<quan.DelMaterialRsp>} TypeScript syntax */

export function DelMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=set_model_db_proxy
// @gen_to: material

/** @type {(r: quan.SetMaterialCategoryReq, b: any) => Promise<quan.SetMaterialCategoryRsp>} TypeScript syntax */

export function SetMaterialCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMaterialCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=get_model_list_db_proxy
// @gen_to: material

/** @type {(r: quan.GetMaterialCategoryListReq, b: any) => Promise<quan.GetMaterialCategoryListRsp>} TypeScript syntax */

export function GetMaterialCategoryList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMaterialCategoryList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=del_model_db_proxy
// @gen_to: material

/** @type {(r: quan.DelMaterialCategoryReq, b: any) => Promise<quan.DelMaterialCategoryRsp>} TypeScript syntax */

export function DelMaterialCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelMaterialCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: material

/** @type {(r: quan.SortMaterialCategoryReq, b: any) => Promise<quan.SortMaterialCategoryRsp>} TypeScript syntax */

export function SortMaterialCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SortMaterialCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// svr options: (ext.UserType) = staff

/** @type {(r: quan.StaffLoginAsCorpCreatorReq, b: any) => Promise<quan.StaffLoginAsCorpCreatorRsp>} TypeScript syntax */

export function StaffLoginAsCorpCreator(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/StaffLoginAsCorpCreator",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: op
// @gen: t=get_model_list_db_proxy
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCorpListStaffReq, b: any) => Promise<quan.GetCorpListStaffRsp>} TypeScript syntax */

export function GetCorpListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpListStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: app

/** @type {(r: quan.GetMyAppListReq, b: any) => Promise<quan.GetMyAppListRsp>} TypeScript syntax */

export function GetMyAppList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMyAppList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen_to: app

/** @type {(r: quan.GetAppListReq, b: any) => Promise<quan.GetAppListRsp>} TypeScript syntax */

export function GetAppList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAppList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 圈量运营后台-应用中心配置
// @desc:
// @error:
// @gen_to: app
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetAppListStaffReq, b: any) => Promise<quan.GetAppListStaffRsp>} TypeScript syntax */

export function GetAppListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAppListStaff",
    "auth": "1"
  }), o));
}
; // @name: 渠道统计
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: channel
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetChannelStatReq, b: any) => Promise<quan.GetChannelStatRsp>} TypeScript syntax */

export function GetChannelStat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannelStat",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 客户统计
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: ext_contact
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetExtContactDetailStatReq, b: any) => Promise<quan.GetExtContactDetailStatRsp>} TypeScript syntax */

export function GetExtContactDetailStat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactDetailStat",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrAppOffSale 应用已下架
// ErrAppNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: app

/** @type {(r: quan.AddAppReq, b: any) => Promise<quan.AddAppRsp>} TypeScript syntax */

export function AddApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrVersionNotExpire 账号未过期不能新购
// ErrUnknowVersionBuyType 版本已过期
// ErrVersionNotFound 付费版本不存在
// ErrValidityTypeInconsistency
// ErrAppNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: order

/** @type {(r: quan.CreateOrderReq, b: any) => Promise<quan.CreateOrderRsp>} TypeScript syntax */

export function CreateOrder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CreateOrder",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: order

/** @type {(r: quan.PayOrderReq, b: any) => Promise<quan.PayOrderRsp>} TypeScript syntax */

export function PayOrder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/PayOrder",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: order

/** @type {(r: quan.GetOrderListReq, b: any) => Promise<quan.GetOrderListRsp>} TypeScript syntax */

export function GetOrderList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetOrderList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: order

/** @type {(r: quan.GetOrderListStaffReq, b: any) => Promise<quan.GetOrderListStaffRsp>} TypeScript syntax */

export function GetOrderListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetOrderListStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrChangeOrderDup
// ErrInvalidOrderState
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: order

/** @type {(r: quan.CancelOrderReq, b: any) => Promise<quan.CancelOrderRsp>} TypeScript syntax */

export function CancelOrder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CancelOrder",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: app
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetAppStaffReq, b: any) => Promise<quan.SetAppStaffRsp>} TypeScript syntax */

export function SetAppStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetAppStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrChangeOrderDup
// ErrOrderHasBeenIssued 订单已经开过发票
// ErrOrderNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=add_model_db_proxy
// @gen_to: invoice

/** @type {(r: quan.AddInvoiceReq, b: any) => Promise<quan.AddInvoiceRsp>} TypeScript syntax */

export function AddInvoice(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddInvoice",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: material

/** @type {(r: quan.BatchDelMaterialReq, b: any) => Promise<quan.BatchDelMaterialRsp>} TypeScript syntax */

export function BatchDelMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDelMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=get_model_db_proxy
// @gen_to: invoice

/** @type {(r: quan.GetInvoiceReq, b: any) => Promise<quan.GetInvoiceRsp>} TypeScript syntax */

export function GetInvoice(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInvoice",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=set_model_db_proxy
// @gen_to: invoice

/** @type {(r: quan.SetInvoiceReq, b: any) => Promise<quan.SetInvoiceRsp>} TypeScript syntax */

export function SetInvoice(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetInvoice",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: invoice

/** @type {(r: quan.GetInvoiceListReq, b: any) => Promise<quan.GetInvoiceListRsp>} TypeScript syntax */

export function GetInvoiceList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInvoiceList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy;m=ModelInvoice
// @gen_to: invoice
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetInvoiceListStaffReq, b: any) => Promise<quan.GetInvoiceListStaffRsp>} TypeScript syntax */

export function GetInvoiceListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInvoiceListStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=set_model_db_proxy;m=ModelInvoice
// @gen_to: invoice
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetInvoiceStaffReq, b: any) => Promise<quan.SetInvoiceStaffRsp>} TypeScript syntax */

export function SetInvoiceStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetInvoiceStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_db_proxy;m=ModelInvoice
// @gen_to: invoice
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetInvoiceStaffReq, b: any) => Promise<quan.GetInvoiceStaffRsp>} TypeScript syntax */

export function GetInvoiceStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInvoiceStaff",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: material

/** @type {(r: quan.BatchMoveMaterialReq, b: any) => Promise<quan.BatchMoveMaterialRsp>} TypeScript syntax */

export function BatchMoveMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchMoveMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: sidebar_tab
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetSidebarTabListAdminReq, b: any) => Promise<quan.GetSidebarTabListAdminRsp>} TypeScript syntax */

export function GetSidebarTabListAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSidebarTabListAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: sidebar_tab

/** @type {(r: quan.SetSidebarTabOnOffAdminReq, b: any) => Promise<quan.SetSidebarTabOnOffAdminRsp>} TypeScript syntax */

export function SetSidebarTabOnOffAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetSidebarTabOnOffAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: sidebar_tab

/** @type {(r: quan.GetSidebarTabListReq, b: any) => Promise<quan.GetSidebarTabListRsp>} TypeScript syntax */

export function GetSidebarTabList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSidebarTabList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen: t=add_model_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.AddSpeechcraftReq, b: any) => Promise<quan.AddSpeechcraftRsp>} TypeScript syntax */

export function AddSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.GetSpeechcraftListReq, b: any) => Promise<quan.GetSpeechcraftListRsp>} TypeScript syntax */

export function GetSpeechcraftList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSpeechcraftList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=set_model_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.SetSpeechcraftReq, b: any) => Promise<quan.SetSpeechcraftRsp>} TypeScript syntax */

export function SetSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.GetSpeechcraftReq, b: any) => Promise<quan.GetSpeechcraftRsp>} TypeScript syntax */

export function GetSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=del_model_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.DelSpeechcraftReq, b: any) => Promise<quan.DelSpeechcraftRsp>} TypeScript syntax */

export function DelSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrSpeechcraftCategoryNameExisted 话术分类已存在
// ErrCorpNotAuth
// @gen: t=add_model_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.AddSpeechcraftCategoryReq, b: any) => Promise<quan.AddSpeechcraftCategoryRsp>} TypeScript syntax */

export function AddSpeechcraftCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddSpeechcraftCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.GetSpeechcraftCategoryListReq, b: any) => Promise<quan.GetSpeechcraftCategoryListRsp>} TypeScript syntax */

export function GetSpeechcraftCategoryList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSpeechcraftCategoryList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=del_model_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.DelSpeechcraftCategoryReq, b: any) => Promise<quan.DelSpeechcraftCategoryRsp>} TypeScript syntax */

export function DelSpeechcraftCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelSpeechcraftCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrSpeechcraftCategoryNameExisted 话术分类已存在
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=set_model_db_proxy
// @gen_to: speechcraft

/** @type {(r: quan.SetSpeechcraftCategoryReq, b: any) => Promise<quan.SetSpeechcraftCategoryRsp>} TypeScript syntax */

export function SetSpeechcraftCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetSpeechcraftCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: speechcraft

/** @type {(r: quan.BatchDelSpeechcraftReq, b: any) => Promise<quan.BatchDelSpeechcraftRsp>} TypeScript syntax */

export function BatchDelSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDelSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: speechcraft

/** @type {(r: quan.BatchMoveSpeechcraftReq, b: any) => Promise<quan.BatchMoveSpeechcraftRsp>} TypeScript syntax */

export function BatchMoveSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchMoveSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrSpeechcraftCategoryNameExisted 话术分类已存在
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: speechcraft

/** @type {(r: quan.SortSpeechcraftCategoryReq, b: any) => Promise<quan.SortSpeechcraftCategoryRsp>} TypeScript syntax */

export function SortSpeechcraftCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SortSpeechcraftCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrSidebarTabNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: sidebar_tab

/** @type {(r: quan.GetSidebarTabReq, b: any) => Promise<quan.GetSidebarTabRsp>} TypeScript syntax */

export function GetSidebarTab(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSidebarTab",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrAppOffSale 应用已下架
// ErrAppNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: app

/** @type {(r: quan.GetAppReq, b: any) => Promise<quan.GetAppRsp>} TypeScript syntax */

export function GetApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetApp",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: ext_contact

/** @type {(r: quan.UpdateExtContactRemarkReq, b: any) => Promise<quan.UpdateExtContactRemarkRsp>} TypeScript syntax */

export function UpdateExtContactRemark(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateExtContactRemark",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// @gen_to: app

/** @type {(r: quan.DelAppReq, b: any) => Promise<quan.DelAppRsp>} TypeScript syntax */

export function DelApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrAppNeedPay 需要支付
// ErrAppNotFound
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: bilin

/** @type {(r: quan.GetBiLinSsoUrlReq, b: any) => Promise<quan.GetBiLinSsoUrlRsp>} TypeScript syntax */

export function GetBiLinSsoUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetBiLinSsoUrl",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrValidityTypeInconsistency
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrAppNotFound
// @gen_to: order

/** @type {(r: quan.CalculatePriceReq, b: any) => Promise<quan.CalculatePriceRsp>} TypeScript syntax */

export function CalculatePrice(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CalculatePrice",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_db_proxy;m=ModelOrder
// @gen_to: order

/** @type {(r: quan.GetOrderReq, b: any) => Promise<quan.GetOrderRsp>} TypeScript syntax */

export function GetOrder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetOrder",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: ext_contact

/** @type {(r: quan.SyncUserReq, b: any) => Promise<quan.SyncUserRsp>} TypeScript syntax */

export function SyncUser(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncUser",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.SortSpeechcraftReq, b: any) => Promise<quan.SortSpeechcraftRsp>} TypeScript syntax */

export function SortSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SortSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrVersionNotFound 付费版本不存在
// @gen_to: version

/** @type {(r: quan.GetVersionConfigReq, b: any) => Promise<quan.GetVersionConfigRsp>} TypeScript syntax */

export function GetVersionConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetVersionConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: version
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetVersionConfigReq, b: any) => Promise<quan.SetVersionConfigRsp>} TypeScript syntax */

export function SetVersionConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetVersionConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: export

/** @type {(r: quan.ExportChannelStatListReq, b: any) => Promise<quan.ExportChannelStatListRsp>} TypeScript syntax */

export function ExportChannelStatList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportChannelStatList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.CountExtContactReq, b: any) => Promise<quan.CountExtContactRsp>} TypeScript syntax */

export function CountExtContact(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CountExtContact",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactListReq, b: any) => Promise<quan.GetExtContactListRsp>} TypeScript syntax */

export function GetExtContactList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_db_proxy;m=ModelOrder
// @gen_to: order
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetOrderStaffReq, b: any) => Promise<quan.GetOrderStaffRsp>} TypeScript syntax */

export function GetOrderStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetOrderStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: version
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetVersionFreeDayReq, b: any) => Promise<quan.GetVersionFreeDayRsp>} TypeScript syntax */

export function GetVersionFreeDay(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetVersionFreeDay",
    "auth": "1"
  }), o));
}
; // @cat: 圈量运营后台
// @name: 试用版设置可试用时长
// @desc:
// @error:
// @gen_to: version
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetVersionFreeDayReq, b: any) => Promise<quan.SetVersionFreeDayRsp>} TypeScript syntax */

export function SetVersionFreeDay(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetVersionFreeDay",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen_to: version

/** @type {(r: quan.GetVersionConfigListReq, b: any) => Promise<quan.GetVersionConfigListRsp>} TypeScript syntax */

export function GetVersionConfigList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetVersionConfigList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrWrongPassword 账号或密码错误
// @gen_to: login
// svr options: (ext.UserType) = pub

/** @type {(r: quan.Login4AuditReq, b: any) => Promise<quan.Login4AuditRsp>} TypeScript syntax */

export function Login4Audit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/Login4Audit",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactWithFollowReq, b: any) => Promise<quan.GetExtContactWithFollowRsp>} TypeScript syntax */

export function GetExtContactWithFollow(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactWithFollow",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// svr options: (ext.UserType) = pub

/** @type {(r: quan.ExperienceQuanReq, b: any) => Promise<quan.ExperienceQuanRsp>} TypeScript syntax */

export function ExperienceQuan(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExperienceQuan",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrVersionNotExpire 账号未过期不能新购
// ErrUnknowVersionBuyType 版本已过期
// ErrVersionNotFound 付费版本不存在
// @gen_to: version

/** @type {(r: quan.CalcVersionPriceReq, b: any) => Promise<quan.CalcVersionPriceRsp>} TypeScript syntax */

export function CalcVersionPrice(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CalcVersionPrice",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: resigned_staff

/** @type {(r: quan.SyncResignedStaffExtContactReq, b: any) => Promise<quan.SyncResignedStaffExtContactRsp>} TypeScript syntax */

export function SyncResignedStaffExtContact(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncResignedStaffExtContact",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: version
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCorpVersionListReq, b: any) => Promise<quan.GetCorpVersionListRsp>} TypeScript syntax */

export function GetCorpVersionList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpVersionList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 导出企业版本列表
// @error:
// @gen_to: version
// svr options: (ext.UserType) = staff

/** @type {(r: quan.ExportCorpVersionListReq, b: any) => Promise<quan.ExportCorpVersionListRsp>} TypeScript syntax */

export function ExportCorpVersionList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportCorpVersionList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: resigned_staff

/** @type {(r: quan.GetResignedStaffListReq, b: any) => Promise<quan.GetResignedStaffListRsp>} TypeScript syntax */

export function GetResignedStaffList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetResignedStaffList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_db_proxy
// @gen_to: resigned_staff

/** @type {(r: quan.GetResignedStaffReq, b: any) => Promise<quan.GetResignedStaffRsp>} TypeScript syntax */

export function GetResignedStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetResignedStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: resigned_staff

/** @type {(r: quan.GetResignedStaffExtContactListReq, b: any) => Promise<quan.GetResignedStaffExtContactListRsp>} TypeScript syntax */

export function GetResignedStaffExtContactList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetResignedStaffExtContactList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: resigned_staff

/** @type {(r: quan.GetResignedStaffGroupChatListReq, b: any) => Promise<quan.GetResignedStaffGroupChatListRsp>} TypeScript syntax */

export function GetResignedStaffGroupChatList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetResignedStaffGroupChatList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: resigned_staff

/** @type {(r: quan.TransferResignedStaffGroupChatReq, b: any) => Promise<quan.TransferResignedStaffGroupChatRsp>} TypeScript syntax */

export function TransferResignedStaffGroupChat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/TransferResignedStaffGroupChat",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotExtContactsPermit 选择的成员没有外部联系人权限，操作失败
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: resigned_staff

/** @type {(r: quan.TransferResignedStaffExtContactReq, b: any) => Promise<quan.TransferResignedStaffExtContactRsp>} TypeScript syntax */

export function TransferResignedStaffExtContact(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/TransferResignedStaffExtContact",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrVersionNotFound 付费版本不存在
// @gen_to: version

/** @type {(r: quan.GetCorpVersionReq, b: any) => Promise<quan.GetCorpVersionRsp>} TypeScript syntax */

export function GetCorpVersion(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpVersion",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: version
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCorpVersionStaffReq, b: any) => Promise<quan.GetCorpVersionStaffRsp>} TypeScript syntax */

export function GetCorpVersionStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpVersionStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: version

/** @type {(r: quan.BatchDeleteUserDistributeReq, b: any) => Promise<quan.BatchDeleteUserDistributeRsp>} TypeScript syntax */

export function BatchDeleteUserDistribute(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDeleteUserDistribute",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrVersionDistributeMax 授权账号分配已到上限
// @gen_to: version

/** @type {(r: quan.BatchAddUserDistributeReq, b: any) => Promise<quan.BatchAddUserDistributeRsp>} TypeScript syntax */

export function BatchAddUserDistribute(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchAddUserDistribute",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUserNotExtContactsPermit 选择的成员没有外部联系人权限，操作失败
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: resigned_staff

/** @type {(r: quan.TransferExtContactAndGroupChat2StaffReq, b: any) => Promise<quan.TransferExtContactAndGroupChat2StaffRsp>} TypeScript syntax */

export function TransferExtContactAndGroupChat2Staff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/TransferExtContactAndGroupChat2Staff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrValidityTypeInconsistency
// ErrAppNotFound
// @gen_to: version
// svr options: (ext.UserType) = staff

/** @type {(r: quan.UpdateCorpVersionStaffReq, b: any) => Promise<quan.UpdateCorpVersionStaffRsp>} TypeScript syntax */

export function UpdateCorpVersionStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateCorpVersionStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrFeatureFlagExisted 特性标签已存在
// ErrCorpIdDoesNotExisted 企业ID不存在
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddFeatureFlagConfigStaffReq, b: any) => Promise<quan.AddFeatureFlagConfigStaffRsp>} TypeScript syntax */

export function AddFeatureFlagConfigStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddFeatureFlagConfigStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelFeatureFlagConfigStaffReq, b: any) => Promise<quan.DelFeatureFlagConfigStaffRsp>} TypeScript syntax */

export function DelFeatureFlagConfigStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelFeatureFlagConfigStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrFeatureFlagDoesNotExisted 特性标签不存在
// ErrCorpIdDoesNotExisted 企业ID不存在
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetFeatureFlagConfigStaffReq, b: any) => Promise<quan.SetFeatureFlagConfigStaffRsp>} TypeScript syntax */

export function SetFeatureFlagConfigStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetFeatureFlagConfigStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetFeatureFlagConfigStaffReq, b: any) => Promise<quan.GetFeatureFlagConfigStaffRsp>} TypeScript syntax */

export function GetFeatureFlagConfigStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetFeatureFlagConfigStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetFeatureFlagConfigListStaffReq, b: any) => Promise<quan.GetFeatureFlagConfigListStaffRsp>} TypeScript syntax */

export function GetFeatureFlagConfigListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetFeatureFlagConfigListStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config

/** @type {(r: quan.GetFeatureFlagEnabledReq, b: any) => Promise<quan.GetFeatureFlagEnabledRsp>} TypeScript syntax */

export function GetFeatureFlagEnabled(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetFeatureFlagEnabled",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: speechcraft
// @gen: t=add_model_db_proxy

/** @type {(r: quan.BatchAddSpeechcraftKeywordReq, b: any) => Promise<quan.BatchAddSpeechcraftKeywordRsp>} TypeScript syntax */

export function BatchAddSpeechcraftKeyword(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchAddSpeechcraftKeyword",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: speechcraft
// @gen: t=del_model_db_proxy

/** @type {(r: quan.DelSpeechcraftKeywordReq, b: any) => Promise<quan.DelSpeechcraftKeywordRsp>} TypeScript syntax */

export function DelSpeechcraftKeyword(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelSpeechcraftKeyword",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: speechcraft
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetSpeechcraftKeywordListReq, b: any) => Promise<quan.GetSpeechcraftKeywordListRsp>} TypeScript syntax */

export function GetSpeechcraftKeywordList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSpeechcraftKeywordList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取授权配置信息
// @desc:
// @error:
// ErrAppNotFound
// @gen_to: auth_conf

/** @type {(r: quan.GetContactAppAuthConfigReq, b: any) => Promise<quan.GetContactAppAuthConfigRsp>} TypeScript syntax */

export function GetContactAppAuthConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetContactAppAuthConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 创建机器人部门+设置部门可见范围
// @desc:
// @error:
// ErrGetWxDeptFailed 获取部门信息失败
// ErrAddWxDeptFailed 创建部门失败
// ErrWxAdminNotLogin
// qrobot.ErrGetWxAppFailed 获取部门信息失败
// ErrAppNotFound
// ErrArgsInvalid 参数无效
// @gen_to: auth_conf

/** @type {(r: quan.AddWwDeptReq, b: any) => Promise<quan.AddWwDeptRsp>} TypeScript syntax */

export function AddWwDept(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddWwDept",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrGetWwAdminLoginQrUrlFailed 获取企业微信登录二维码链接失败
// @gen_to: auth_conf

/** @type {(r: quan.GetWwAdminLoginQrUrlReq, b: any) => Promise<quan.GetWwAdminLoginQrUrlRsp>} TypeScript syntax */

export function GetWwAdminLoginQrUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWwAdminLoginQrUrl",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserDoesNotTheWwAdmin 该用户不是该企业的管理员
// ErrWwAdminSelectCorp2LoginFailed 企业微信选择企业登录失败
// ErrGetWwAdminLoginStateFailed 获取企业微信登录状态失败
// @gen_to: auth_conf

/** @type {(r: quan.GetWwAdminLoginStateReq, b: any) => Promise<quan.GetWwAdminLoginStateRsp>} TypeScript syntax */

export function GetWwAdminLoginState(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWwAdminLoginState",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserDoesNotTheWwAdmin 该用户不是该企业的管理员
// ErrWwAdminSelectCorp2LoginFailed 企业微信选择企业登录失败
// @gen_to: auth_conf

/** @type {(r: quan.WwAdminSelectCorp2LoginReq, b: any) => Promise<quan.WwAdminSelectCorp2LoginRsp>} TypeScript syntax */

export function WwAdminSelectCorp2Login(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/WwAdminSelectCorp2Login",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 设置通讯录同步
// @desc:
// @error:
// ErrWxAdminNotLogin
// ErrWxAdminEarlyBindBizEmail 企业微信已经绑定企业邮箱
// ErrWxAdminEditableContactApp 开启企业通讯录可编辑权限失败
// qrobot.ErrGetWxContactAppInfoFailed 获取企业微信通讯录信息失败
// @gen_to: auth_conf

/** @type {(r: quan.EditableContactAppReq, b: any) => Promise<quan.EditableContactAppRsp>} TypeScript syntax */

export function EditableContactApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/EditableContactApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 配置员工信息+上传默认机器人头像到素材库
// @desc:
// @error:
// qrobot.ErrCorpRobotProfileNotFound
// @gen_to: auth_conf

/** @type {(r: quan.SetRobotStaffProfileReq, b: any) => Promise<quan.SetRobotStaffProfileRsp>} TypeScript syntax */

export function SetRobotStaffProfile(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetRobotStaffProfile",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrWxAdminNotLogin 企业微信未登录
// @gen_to: auth_conf

/** @type {(r: quan.GetWwDeptListReq, b: any) => Promise<quan.GetWwDeptListRsp>} TypeScript syntax */

export function GetWwDeptList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWwDeptList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: chat
// @gen: t=get_model_list_db_proxy

/** @type {(r: quan.GetGroupChatListSysReq, b: any) => Promise<quan.GetGroupChatListSysRsp>} TypeScript syntax */

export function GetGroupChatListSys(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetGroupChatListSys",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// qrobot.ErrCorpRobotProfileNotFound
// @gen_to: auth_conf

/** @type {(r: quan.GetRobotStaffProfileReq, b: any) => Promise<quan.GetRobotStaffProfileRsp>} TypeScript syntax */

export function GetRobotStaffProfile(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRobotStaffProfile",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: resigned_staff

/** @type {(r: quan.GetRobotStaffListReq, b: any) => Promise<quan.GetRobotStaffListRsp>} TypeScript syntax */

export function GetRobotStaffList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRobotStaffList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrDelUserFailed 删除用户失败
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: resigned_staff

/** @type {(r: quan.BatchDelRobotUserReq, b: any) => Promise<quan.BatchDelRobotUserRsp>} TypeScript syntax */

export function BatchDelRobotUser(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDelRobotUser",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotExtContactsPermit 选择的成员没有外部联系人权限，操作失败
// ErrDelUserFailed 删除用户失败
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: resigned_staff

/** @type {(r: quan.DelAndTransferRobotStaffAssetsReq, b: any) => Promise<quan.DelAndTransferRobotStaffAssetsRsp>} TypeScript syntax */

export function DelAndTransferRobotStaffAssets(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelAndTransferRobotStaffAssets",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen_to: auth_conf

/** @type {(r: quan.SetContactAppAuthConfigReq, b: any) => Promise<quan.SetContactAppAuthConfigRsp>} TypeScript syntax */

export function SetContactAppAuthConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetContactAppAuthConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrMaterialNotFound
// ErrCorpNotAuth
// @gen_to: material

/** @type {(r: quan.UploadMaterial2WwMediaReq, b: any) => Promise<quan.UploadMaterial2WwMediaRsp>} TypeScript syntax */

export function UploadMaterial2WwMedia(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UploadMaterial2WwMedia",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config

/** @type {(r: quan.GetFeatureFlagMapReq, b: any) => Promise<quan.GetFeatureFlagMapRsp>} TypeScript syntax */

export function GetFeatureFlagMap(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetFeatureFlagMap",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 用户完成安装流程后，帮用户以超级管理员身份自动登录
// @error:
// ErrMissWwUserId
// ErrMissWwCorpId 请选择要授权安装的企业微信
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrCorpNotAuth
// svr options: (ext.UserType) = account

/** @type {(r: quan.Login4InstallReq, b: any) => Promise<quan.Login4InstallRsp>} TypeScript syntax */

export function Login4Install(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/Login4Install",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMiniProgramPathRepeat 小程序路径重复
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=add_model_db_proxy;m=ModelMiniProgram
// @gen_to: miniprogram

/** @type {(r: quan.AddMiniProgramReq, b: any) => Promise<quan.AddMiniProgramRsp>} TypeScript syntax */

export function AddMiniProgram(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddMiniProgram",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=del_model_db_proxy;m=ModelMiniProgram
// @gen_to: miniprogram

/** @type {(r: quan.DelMiniProgramReq, b: any) => Promise<quan.DelMiniProgramRsp>} TypeScript syntax */

export function DelMiniProgram(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelMiniProgram",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMiniProgramPathRepeat 小程序路径重复
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=set_model_db_proxy;m=ModelMiniProgram
// @gen_to: miniprogram

/** @type {(r: quan.SetMiniProgramReq, b: any) => Promise<quan.SetMiniProgramRsp>} TypeScript syntax */

export function SetMiniProgram(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMiniProgram",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=get_model_db_proxy;m=ModelMiniProgram
// @gen_to: miniprogram

/** @type {(r: quan.GetMiniProgramReq, b: any) => Promise<quan.GetMiniProgramRsp>} TypeScript syntax */

export function GetMiniProgram(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMiniProgram",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=get_model_list_db_proxy;m=ModelMiniProgram
// @gen_to: miniprogram

/** @type {(r: quan.GetMiniProgramListReq, b: any) => Promise<quan.GetMiniProgramListRsp>} TypeScript syntax */

export function GetMiniProgramList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMiniProgramList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrFeatureFlagDoesNotExisted 特性标签不存在
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SyncFeatureFlag2ReleaseStaffReq, b: any) => Promise<quan.SyncFeatureFlag2ReleaseStaffRsp>} TypeScript syntax */

export function SyncFeatureFlag2ReleaseStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncFeatureFlag2ReleaseStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: speechcraft

/** @type {(r: quan.BatchDelSpeechcraftKeywordReq, b: any) => Promise<quan.BatchDelSpeechcraftKeywordRsp>} TypeScript syntax */

export function BatchDelSpeechcraftKeyword(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDelSpeechcraftKeyword",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=add_model_db_proxy;m=ModelMessageAuditorConfig
// @gen_to: auditor_config

/** @type {(r: quan.AddMessageAuditorConfigReq, b: any) => Promise<quan.AddMessageAuditorConfigRsp>} TypeScript syntax */

export function AddMessageAuditorConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddMessageAuditorConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=del_model_db_proxy;m=ModelMessageAuditorConfig
// @gen_to: auditor_config

/** @type {(r: quan.DelMessageAuditorConfigReq, b: any) => Promise<quan.DelMessageAuditorConfigRsp>} TypeScript syntax */

export function DelMessageAuditorConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelMessageAuditorConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=set_model_db_proxy;m=ModelMessageAuditorConfig
// @gen_to: auditor_config

/** @type {(r: quan.SetMessageAuditorConfigReq, b: any) => Promise<quan.SetMessageAuditorConfigRsp>} TypeScript syntax */

export function SetMessageAuditorConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMessageAuditorConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=get_model_db_proxy;m=ModelMessageAuditorConfig
// @gen_to: auditor_config

/** @type {(r: quan.GetMessageAuditorConfigReq, b: any) => Promise<quan.GetMessageAuditorConfigRsp>} TypeScript syntax */

export function GetMessageAuditorConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMessageAuditorConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrCorpNotAuth
// @gen: t=get_model_list_db_proxy;m=ModelMessageAuditorConfig
// @gen_to: auditor_config

/** @type {(r: quan.GetMessageAuditorConfigListReq, b: any) => Promise<quan.GetMessageAuditorConfigListRsp>} TypeScript syntax */

export function GetMessageAuditorConfigList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMessageAuditorConfigList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=set_model_db_proxy;m=ModelMessageAuditSwitch
// @gen_to: audit_switch

/** @type {(r: quan.SetMessageAuditSwitchReq, b: any) => Promise<quan.SetMessageAuditSwitchRsp>} TypeScript syntax */

export function SetMessageAuditSwitch(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMessageAuditSwitch",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=get_model_db_proxy;m=ModelMessageAuditSwitch
// @gen_to: audit_switch

/** @type {(r: quan.GetMessageAuditSwitchReq, b: any) => Promise<quan.GetMessageAuditSwitchRsp>} TypeScript syntax */

export function GetMessageAuditSwitch(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMessageAuditSwitch",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMessageAuditStateException
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: audit

/** @type {(r: quan.BatchApproveMessageAuditReq, b: any) => Promise<quan.BatchApproveMessageAuditRsp>} TypeScript syntax */

export function BatchApproveMessageAudit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchApproveMessageAudit",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrMessageAuditStateException
// @gen_to: audit

/** @type {(r: quan.BatchRejectMessageAuditReq, b: any) => Promise<quan.BatchRejectMessageAuditRsp>} TypeScript syntax */

export function BatchRejectMessageAudit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchRejectMessageAudit",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_db_proxy;m=ModelMessageAudit
// @gen_to: audit

/** @type {(r: quan.GetMessageAuditReq, b: any) => Promise<quan.GetMessageAuditRsp>} TypeScript syntax */

export function GetMessageAudit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMessageAudit",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrCorpNotAuth
// @gen: t=get_model_list_db_proxy;m=ModelMessageAudit
// @gen_to: audit

/** @type {(r: quan.GetMessageAuditListReq, b: any) => Promise<quan.GetMessageAuditListRsp>} TypeScript syntax */

export function GetMessageAuditList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMessageAuditList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: audit

/** @type {(r: quan.GetMessageAuditByTaskIdReq, b: any) => Promise<quan.GetMessageAuditByTaskIdRsp>} TypeScript syntax */

export function GetMessageAuditByTaskId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMessageAuditByTaskId",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: audit

/** @type {(r: quan.SendNotify2AuditorListReq, b: any) => Promise<quan.SendNotify2AuditorListRsp>} TypeScript syntax */

export function SendNotify2AuditorList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SendNotify2AuditorList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: quan.GetCorpByWwInnerCorpIdReq, b: any) => Promise<quan.GetCorpByWwInnerCorpIdRsp>} TypeScript syntax */

export function GetCorpByWwInnerCorpId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpByWwInnerCorpId",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: user

/** @type {(r: quan.SetUserRobotsReq, b: any) => Promise<quan.SetUserRobotsRsp>} TypeScript syntax */

export function SetUserRobots(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetUserRobots",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: user

/** @type {(r: quan.GetUserRobotsReq, b: any) => Promise<quan.GetUserRobotsRsp>} TypeScript syntax */

export function GetUserRobots(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserRobots",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: user

/** @type {(r: quan.BatchAddUserRobotsReq, b: any) => Promise<quan.BatchAddUserRobotsRsp>} TypeScript syntax */

export function BatchAddUserRobots(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchAddUserRobots",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrRoleNameExist 管理组名称已被使用，请更换名称
// @gen_to: role
// @gen: t=add_model_db_proxy;m=ModelRole

/** @type {(r: quan.AddRoleReq, b: any) => Promise<quan.AddRoleRsp>} TypeScript syntax */

export function AddRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrRoleNameExist 管理组名称已被使用，请更换名称
// ErrRoleNotAllowEdit 该角色名不允许编辑
// @gen_to: role
// @gen: t=update_model_db_proxy;m=ModelRole

/** @type {(r: quan.UpdateRoleReq, b: any) => Promise<quan.UpdateRoleRsp>} TypeScript syntax */

export function UpdateRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: role
// @gen: t=del_model_db_proxy;m=ModelRole

/** @type {(r: quan.DelRoleReq, b: any) => Promise<quan.DelRoleRsp>} TypeScript syntax */

export function DelRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrRoleNameExist 角色名称已被使用，请更换名称
// @gen_to: role

/** @type {(r: quan.CopyRoleReq, b: any) => Promise<quan.CopyRoleRsp>} TypeScript syntax */

export function CopyRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CopyRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: role

/** @type {(r: quan.SortRoleReq, b: any) => Promise<quan.SortRoleRsp>} TypeScript syntax */

export function SortRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SortRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy;m=ModelRole
// @gen_to: role

/** @type {(r: quan.GetRoleListReq, b: any) => Promise<quan.GetRoleListRsp>} TypeScript syntax */

export function GetRoleList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRoleList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: role

/** @type {(r: quan.GetPermissionReq, b: any) => Promise<quan.GetPermissionRsp>} TypeScript syntax */

export function GetPermission(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetPermission",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen: t=add_model_db_proxy;m=ModelPermission
// @gen_to: op
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddPermissionReq, b: any) => Promise<quan.AddPermissionRsp>} TypeScript syntax */

export function AddPermission(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddPermission",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen: t=set_model_db_proxy;m=ModelPermission
// @gen_to: op
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetPermissionReq, b: any) => Promise<quan.SetPermissionRsp>} TypeScript syntax */

export function SetPermission(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetPermission",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy;m=ModelPermission
// @gen_to: role

/** @type {(r: quan.GetPermissionListReq, b: any) => Promise<quan.GetPermissionListRsp>} TypeScript syntax */

export function GetPermissionList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetPermissionList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=del_model_db_proxy;m=ModelPermission
// @gen_to: op
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelPermissionReq, b: any) => Promise<quan.DelPermissionRsp>} TypeScript syntax */

export function DelPermission(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelPermission",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: op
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetRoleStaffReq, b: any) => Promise<quan.SetRoleStaffRsp>} TypeScript syntax */

export function SetRoleStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetRoleStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: op

/** @type {(r: quan.GetDefaultRoleListReq, b: any) => Promise<quan.GetDefaultRoleListRsp>} TypeScript syntax */

export function GetDefaultRoleList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDefaultRoleList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: role

/** @type {(r: quan.TransferCreatorReq, b: any) => Promise<quan.TransferCreatorRsp>} TypeScript syntax */

export function TransferCreator(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/TransferCreator",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: role

/** @type {(r: quan.UpdateApiListReq, b: any) => Promise<quan.UpdateApiListRsp>} TypeScript syntax */

export function UpdateApiList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateApiList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpVersionExpire 企业版本已过期
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: role

/** @type {(r: quan.SetUserRoleReq, b: any) => Promise<quan.SetUserRoleRsp>} TypeScript syntax */

export function SetUserRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetUserRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// wechat.ErrWechat 系统错误
// wechat.ErrInvalidRequest 无效的请求
// wechat.ErrMpComponentNotFound 第三方平台不存在
// @gen_to: wechat

/** @type {(r: quan.GetWechatAuthUrlReq, b: any) => Promise<quan.GetWechatAuthUrlRsp>} TypeScript syntax */

export function GetWechatAuthUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWechatAuthUrl",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围

/** @type {(r: quan.BatchSetCorpTag2GroupReq, b: any) => Promise<quan.BatchSetCorpTag2GroupRsp>} TypeScript syntax */

export function BatchSetCorpTag2Group(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetCorpTag2Group",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: role

/** @type {(r: quan.GetRoleListByUidSysReq, b: any) => Promise<quan.GetRoleListByUidSysRsp>} TypeScript syntax */

export function GetRoleListByUidSys(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRoleListByUidSys",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// wechat.ErrWechatAlreadyAuthorize 该公众号已授权至其他企业
// wechat.ErrInvalidRequest 无效的请求
// wechat.ErrMpComponentNotFound 第三方平台不存在
// wechat.ErrWechat 系统错误
// @gen_to: wechat

/** @type {(r: quan.WechatAuthorizedReq, b: any) => Promise<quan.WechatAuthorizedRsp>} TypeScript syntax */

export function WechatAuthorized(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/WechatAuthorized",
    "auth": "1"
  }), o));
}
; // @gen_to: wechat

/** @type {(r: quan.SubmitAuditReq, b: any) => Promise<quan.SubmitAuditRsp>} TypeScript syntax */

export function SubmitAudit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SubmitAudit",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: wechat
// @gen: t=get_model_list_dbx

/** @type {(r: quan.GetWechatListReq, b: any) => Promise<quan.GetWechatListRsp>} TypeScript syntax */

export function GetWechatList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWechatList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.GetCategoryChannelLiveCodeReq, b: any) => Promise<quan.GetCategoryChannelLiveCodeRsp>} TypeScript syntax */

export function GetCategoryChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCategoryChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: wechat
// svr options: (ext.UserType) = pub

/** @type {(r: quan.LoginWechatByCodeReq, b: any) => Promise<quan.LoginWechatByCodeRsp>} TypeScript syntax */

export function LoginWechatByCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/LoginWechatByCode",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUnsupportedAccountType 不支持的账号类型
// ErrFollowTaggingTaskInProgress 客户打标签任务进行中
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrFollowTaggingTaskInProgress 客户打标签任务进行中
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrUnsupportedAccountType 不支持的账号类型

/** @type {(r: quan.BatchSetCorpTag2AllFollowReq, b: any) => Promise<quan.BatchSetCorpTag2AllFollowRsp>} TypeScript syntax */

export function BatchSetCorpTag2AllFollow(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetCorpTag2AllFollow",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: quan.CheckTaggingStateReq, b: any) => Promise<quan.CheckTaggingStateRsp>} TypeScript syntax */

export function CheckTaggingState(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckTaggingState",
    "auth": "1"
  }), o));
}
; // @cat: 预览生成渠道活码
// @name:
// @desc:
// @error:
// wework.ErrWwBizErr
// ErrUserNotInAppScope
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrUserNotActive 选择了未激活企业微信或未实名认证的成员，操作失败
// ErrAppScopeForbidden 应用无权限，请检查配置
// ErrCorpNotAuth
// storage.ErrResourceConflict 资源已存在
// storage.ErrUploadFail
// storage.ErrConfigMiss 配置缺失
// @gen: t=add_model_db_proxy
// @gen_to: live_code

/** @type {(r: quan.PreviewLiveCodeWithUserHeadPicReq, b: any) => Promise<quan.PreviewLiveCodeWithUserHeadPicRsp>} TypeScript syntax */

export function PreviewLiveCodeWithUserHeadPic(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/PreviewLiveCodeWithUserHeadPic",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=add_model_db_proxy;m=ModelPayConfig
// @gen_to: wechat_mch

/** @type {(r: quan.AddPayConfigReq, b: any) => Promise<quan.AddPayConfigRsp>} TypeScript syntax */

export function AddPayConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddPayConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrCorpNotAuth
// @gen: t=del_model_db_proxy;m=ModelPayConfig
// @gen_to: wechat_mch

/** @type {(r: quan.DelPayConfigReq, b: any) => Promise<quan.DelPayConfigRsp>} TypeScript syntax */

export function DelPayConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelPayConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=set_model_db_proxy;m=ModelPayConfig
// @gen_to: wechat_mch

/** @type {(r: quan.SetPayConfigReq, b: any) => Promise<quan.SetPayConfigRsp>} TypeScript syntax */

export function SetPayConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetPayConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen: t=get_model_list_dbx;m=ModelPayConfig
// @gen_to: wechat_mch

/** @type {(r: quan.GetPayConfigListReq, b: any) => Promise<quan.GetPayConfigListRsp>} TypeScript syntax */

export function GetPayConfigList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetPayConfigList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: material

/** @type {(r: quan.BatchAddMaterialReq, b: any) => Promise<quan.BatchAddMaterialRsp>} TypeScript syntax */

export function BatchAddMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchAddMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: wechat

/** @type {(r: quan.AuthorizerBindMchReq, b: any) => Promise<quan.AuthorizerBindMchRsp>} TypeScript syntax */

export function AuthorizerBindMch(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AuthorizerBindMch",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: wechat

/** @type {(r: quan.GetWechatUserSysReq, b: any) => Promise<quan.GetWechatUserSysRsp>} TypeScript syntax */

export function GetWechatUserSys(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWechatUserSys",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// ErrPhoneHasRegister 该号码已注册
// @gen_to: auth
// svr options: (ext.UserType) = pub

/** @type {(r: quan.RegisterByPhoneReq, b: any) => Promise<quan.RegisterByPhoneRsp>} TypeScript syntax */

export function RegisterByPhone(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/RegisterByPhone",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:
// verifycode.ErrWrongVerifyCode
// @gen_to: auth
// svr options: (ext.UserType) = pub

/** @type {(r: quan.LoginByPhoneReq, b: any) => Promise<quan.LoginByPhoneRsp>} TypeScript syntax */

export function LoginByPhone(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/LoginByPhone",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: auth
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetAccountInfoReq, b: any) => Promise<quan.GetAccountInfoRsp>} TypeScript syntax */

export function GetAccountInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAccountInfo",
    "auth": "2"
  }), o));
}
; // @cat:
// @name: 基础账号信息
// @desc: 登录圈量系统的账号，参照 quan_account 的概念
// @error:
// @gen_to: account

/** @type {(r: quan.GetBaseAccountInfoReq, b: any) => Promise<quan.GetBaseAccountInfoRsp>} TypeScript syntax */

export function GetBaseAccountInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetBaseAccountInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: auth
// svr options: (ext.UserType) = account

/** @type {(r: quan.UnbindAccountCorpReq, b: any) => Promise<quan.UnbindAccountCorpRsp>} TypeScript syntax */

export function UnbindAccountCorp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UnbindAccountCorp",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpAccessDeny 没有该企业的权限
// @gen_to: auth
// svr options: (ext.UserType) = account

/** @type {(r: quan.LoginAsCorpReq, b: any) => Promise<quan.LoginAsCorpRsp>} TypeScript syntax */

export function LoginAsCorp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/LoginAsCorp",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrCorpNotAuth
// @gen_to: auth

/** @type {(r: quan.GetAccountSidReq, b: any) => Promise<quan.GetAccountSidRsp>} TypeScript syntax */

export function GetAccountSid(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAccountSid",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrGetWxAdminLoginQrUrlFailed 获取登录二维码失败
// @gen_to: auth
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetWxAdminLoginQrUrlV2Req, b: any) => Promise<quan.GetWxAdminLoginQrUrlV2Rsp>} TypeScript syntax */

export function GetWxAdminLoginQrUrlV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWxAdminLoginQrUrlV2",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserDoesNotTheWxAdmin
// ErrWxAdminSelectCorp2LoginFailed
// ErrGetWxAdminLoginStateFailed 获取登录状态失败
// ErrMissOpenId 请扫公众号二维码进行登录
// ErrMissWwCorpId 请选择要授权安装的企业微信
// @gen_to: auth
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetWxAdminLoginStateV2Req, b: any) => Promise<quan.GetWxAdminLoginStateV2Rsp>} TypeScript syntax */

export function GetWxAdminLoginStateV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWxAdminLoginStateV2",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: auth_conf
// svr options: (ext.UserType) = account

/** @type {(r: quan.GetInstallDataReq, b: any) => Promise<quan.GetInstallDataRsp>} TypeScript syntax */

export function GetInstallData(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetInstallData",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetAdvanceExtContactListReq, b: any) => Promise<quan.GetAdvanceExtContactListRsp>} TypeScript syntax */

export function GetAdvanceExtContactList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAdvanceExtContactList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetAdvanceExtContactResultReq, b: any) => Promise<quan.GetAdvanceExtContactResultRsp>} TypeScript syntax */

export function GetAdvanceExtContactResult(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAdvanceExtContactResult",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 检查成员是否在指定群中
// @desc:
// @error:
// @gen_to: chat
// svr options: (ext.UserType) = pub

/** @type {(r: quan.CheckMemberInGroupReq, b: any) => Promise<quan.CheckMemberInGroupRsp>} TypeScript syntax */

export function CheckMemberInGroup(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckMemberInGroup",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: dept

/** @type {(r: quan.SyncCorpDeptReq, b: any) => Promise<quan.SyncCorpDeptRsp>} TypeScript syntax */

export function SyncCorpDept(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncCorpDept",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: dept

/** @type {(r: quan.GetCorpDeptListReq, b: any) => Promise<quan.GetCorpDeptListRsp>} TypeScript syntax */

export function GetCorpDeptList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpDeptList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=add_model_db_proxy;m=ModelMenu
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddMenuReq, b: any) => Promise<quan.AddMenuRsp>} TypeScript syntax */

export function AddMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=set_model_db_proxy;m=ModelMenu
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetMenuReq, b: any) => Promise<quan.SetMenuRsp>} TypeScript syntax */

export function SetMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=del_model_db_proxy;m=ModelMenu
// @gen_to: menu

/** @type {(r: quan.DelMenuReq, b: any) => Promise<quan.DelMenuRsp>} TypeScript syntax */

export function DelMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy;m=ModelMenu
// @gen_to: menu

/** @type {(r: quan.GetMenuListReq, b: any) => Promise<quan.GetMenuListRsp>} TypeScript syntax */

export function GetMenuList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMenuList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: role

/** @type {(r: quan.GetUserList4RoleReq, b: any) => Promise<quan.GetUserList4RoleRsp>} TypeScript syntax */

export function GetUserList4Role(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserList4Role",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_db_proxy;m=ModelRole
// @gen_to: role

/** @type {(r: quan.GetRoleReq, b: any) => Promise<quan.GetRoleRsp>} TypeScript syntax */

export function GetRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetMenuTemplateConfigReq, b: any) => Promise<quan.SetMenuTemplateConfigRsp>} TypeScript syntax */

export function SetMenuTemplateConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMenuTemplateConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: menu

/** @type {(r: quan.GetMenuTemplateConfigReq, b: any) => Promise<quan.GetMenuTemplateConfigRsp>} TypeScript syntax */

export function GetMenuTemplateConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMenuTemplateConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SwapMenuReq, b: any) => Promise<quan.SwapMenuRsp>} TypeScript syntax */

export function SwapMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SwapMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取简单的群详情，不带群成员
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: chat

/** @type {(r: quan.GetGroupChatWithoutMemberReq, b: any) => Promise<quan.GetGroupChatWithoutMemberRsp>} TypeScript syntax */

export function GetGroupChatWithoutMember(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetGroupChatWithoutMember",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_dbx;m=ModelAccount
// @gen_to: auth

/** @type {(r: quan.GetAccountListReq, b: any) => Promise<quan.GetAccountListRsp>} TypeScript syntax */

export function GetAccountList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAccountList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: auth

/** @type {(r: quan.GetTmpAccountSidReq, b: any) => Promise<quan.GetTmpAccountSidRsp>} TypeScript syntax */

export function GetTmpAccountSid(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetTmpAccountSid",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUnsupportedActiveState
// ErrUnsupportedAccountType 不支持的账号类型

/** @type {(r: quan.GetSimpleUserListReq, b: any) => Promise<quan.GetSimpleUserListRsp>} TypeScript syntax */

export function GetSimpleUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSimpleUserList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 导出企业标签
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: export

/** @type {(r: quan.ExportCorpTagReq, b: any) => Promise<quan.ExportCorpTagRsp>} TypeScript syntax */

export function ExportCorpTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportCorpTag",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 导入excel, 修改外部联系人信息
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: import

/** @type {(r: quan.ImportExtContactFollowReq, b: any) => Promise<quan.ImportExtContactFollowRsp>} TypeScript syntax */

export function ImportExtContactFollow(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ImportExtContactFollow",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen: t=get_model_list_dbx;m=ModelImportRecord
// @gen_to: import

/** @type {(r: quan.GetImportRecordListReq, b: any) => Promise<quan.GetImportRecordListRsp>} TypeScript syntax */

export function GetImportRecordList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetImportRecordList",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: channel_live_code_import

/** @type {(r: quan.GetChannelImportRecordListReq, b: any) => Promise<quan.GetChannelImportRecordListRsp>} TypeScript syntax */

export function GetChannelImportRecordList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannelImportRecordList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_dbx;m=ModelImportRecord
// @gen_to: import

/** @type {(r: quan.AddImportRecordReq, b: any) => Promise<quan.AddImportRecordRsp>} TypeScript syntax */

export function AddImportRecord(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddImportRecord",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_dbx;m=ModelImportRecord
// @gen_to: import

/** @type {(r: quan.UpdateImportRecordReq, b: any) => Promise<quan.UpdateImportRecordRsp>} TypeScript syntax */

export function UpdateImportRecord(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateImportRecord",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: import

/** @type {(r: quan.CheckExcel4ExtContactFollowReq, b: any) => Promise<quan.CheckExcel4ExtContactFollowRsp>} TypeScript syntax */

export function CheckExcel4ExtContactFollow(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckExcel4ExtContactFollow",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// ErrCorpNotAuth
// @gen_to: sync

/** @type {(r: quan.SyncExtContactV2Req, b: any) => Promise<quan.SyncExtContactV2Rsp>} TypeScript syntax */

export function SyncExtContactV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncExtContactV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: sync

/** @type {(r: smq.ConsumeReq, b: any) => Promise<smq.ConsumeRsp>} TypeScript syntax */

export function RecvSyncExtContactMqMsg(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/RecvSyncExtContactMqMsg",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: notify_config

/** @type {(r: quan.GetNotifyConfigListReq, b: any) => Promise<quan.GetNotifyConfigListRsp>} TypeScript syntax */

export function GetNotifyConfigList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetNotifyConfigList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: notify_config

/** @type {(r: quan.SetNotifyConfigReq, b: any) => Promise<quan.SetNotifyConfigRsp>} TypeScript syntax */

export function SetNotifyConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetNotifyConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取企业群数量配置列表
// @desc:
// @error:
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCorpGroupNumConfigReq, b: any) => Promise<quan.GetCorpGroupNumConfigRsp>} TypeScript syntax */

export function GetCorpGroupNumConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpGroupNumConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 添加企业群数量配置
// @desc:
// @error:
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddCorpGroupNumConfigReq, b: any) => Promise<quan.AddCorpGroupNumConfigRsp>} TypeScript syntax */

export function AddCorpGroupNumConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddCorpGroupNumConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 修改企业群数量配置
// @desc:
// @error:
// svr options: (ext.UserType) = staff

/** @type {(r: quan.UpdateCorpGroupNumConfigReq, b: any) => Promise<quan.UpdateCorpGroupNumConfigRsp>} TypeScript syntax */

export function UpdateCorpGroupNumConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateCorpGroupNumConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 删除企业群数量配置
// @desc:
// @error:
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelCorpGroupNumConfigReq, b: any) => Promise<quan.DelCorpGroupNumConfigRsp>} TypeScript syntax */

export function DelCorpGroupNumConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelCorpGroupNumConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_dbx
// @gen_to: ext_contact

/** @type {(r: quan.GetDupExtContactFollowListV2Req, b: any) => Promise<quan.GetDupExtContactFollowListV2Rsp>} TypeScript syntax */

export function GetDupExtContactFollowListV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDupExtContactFollowListV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=add_model_db_proxy
// @gen_to: ext_contact_transfer_customer

/** @type {(r: quan.AddExtContactTransferCustomerTaskReq, b: any) => Promise<quan.AddExtContactTransferCustomerTaskRsp>} TypeScript syntax */

export function AddExtContactTransferCustomerTask(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddExtContactTransferCustomerTask",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_dbx
// @gen_to: ext_contact_transfer_customer

/** @type {(r: quan.GetExtContactTransferCustomerRecordListReq, b: any) => Promise<quan.GetExtContactTransferCustomerRecordListRsp>} TypeScript syntax */

export function GetExtContactTransferCustomerRecordList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactTransferCustomerRecordList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 当前可用账号类型
// @desc: 用于在职继承选择成员
// @error:
// @gen_to: user

/** @type {(r: quan.GetAvailableAccountTypeReq, b: any) => Promise<quan.GetAvailableAccountTypeRsp>} TypeScript syntax */

export function GetAvailableAccountType(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAvailableAccountType",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.AddChannelLiveCode4BatchSingleReq, b: any) => Promise<quan.AddChannelLiveCode4BatchSingleRsp>} TypeScript syntax */

export function AddChannelLiveCode4BatchSingle(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddChannelLiveCode4BatchSingle",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.BatchDelChannelLiveCodeReq, b: any) => Promise<quan.BatchDelChannelLiveCodeRsp>} TypeScript syntax */

export function BatchDelChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDelChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.BatchDelAllChannelLiveCodeReq, b: any) => Promise<quan.BatchDelAllChannelLiveCodeRsp>} TypeScript syntax */

export function BatchDelAllChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDelAllChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.BatchDownloadChannelLiveCodeReq, b: any) => Promise<quan.BatchDownloadChannelLiveCodeRsp>} TypeScript syntax */

export function BatchDownloadChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDownloadChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: paccount

/** @type {(r: quan.GetExtContactFollowListPAccountReq, b: any) => Promise<quan.GetExtContactFollowListPAccountRsp>} TypeScript syntax */

export function GetExtContactFollowListPAccount(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactFollowListPAccount",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取某个素材下的小程序路径列表
// @error:
// @gen_to: material.go

/** @type {(r: quan.GetMaterialYcPagePathListReq, b: any) => Promise<quan.GetMaterialYcPagePathListRsp>} TypeScript syntax */

export function GetMaterialYcPagePathList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMaterialYcPagePathList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactIdListReq, b: any) => Promise<quan.GetExtContactIdListRsp>} TypeScript syntax */

export function GetExtContactIdList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactIdList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetAdvanceExtContactResultAsyncReq, b: any) => Promise<quan.GetAdvanceExtContactResultAsyncRsp>} TypeScript syntax */

export function GetAdvanceExtContactResultAsync(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAdvanceExtContactResultAsync",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config

/** @type {(r: quan.SetNonAuthAppConfig4InstallReq, b: any) => Promise<quan.SetNonAuthAppConfig4InstallRsp>} TypeScript syntax */

export function SetNonAuthAppConfig4Install(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetNonAuthAppConfig4Install",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 编辑某个素材下的小程序路径
// @error:
// @gen_to: material

/** @type {(r: quan.SetMaterialYcPagePathReq, b: any) => Promise<quan.SetMaterialYcPagePathRsp>} TypeScript syntax */

export function SetMaterialYcPagePath(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMaterialYcPagePath",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 删除某个素材下的小程序路径
// @error:
// @gen_to: material

/** @type {(r: quan.DelMaterialYcPagePathReq, b: any) => Promise<quan.DelMaterialYcPagePathRsp>} TypeScript syntax */

export function DelMaterialYcPagePath(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelMaterialYcPagePath",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 圈量小程序路径列表
// @error:
// @gen_to: miniprogram

/** @type {(r: quan.GetMiniProgramPagePathListReq, b: any) => Promise<quan.GetMiniProgramPagePathListRsp>} TypeScript syntax */

export function GetMiniProgramPagePathList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMiniProgramPagePathList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 添加圈量小程序路径
// @error:
// @gen_to: miniprogram

/** @type {(r: quan.AddMiniProgramPagePathReq, b: any) => Promise<quan.AddMiniProgramPagePathRsp>} TypeScript syntax */

export function AddMiniProgramPagePath(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddMiniProgramPagePath",
    "auth": "1"
  }), o));
}
; // @desc: 编辑圈量小程序路径
// @gen_to: miniprogram

/** @type {(r: quan.SetMiniProgramPagePathReq, b: any) => Promise<quan.SetMiniProgramPagePathRsp>} TypeScript syntax */

export function SetMiniProgramPagePath(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetMiniProgramPagePath",
    "auth": "1"
  }), o));
}
; // @desc: 删除圈量小程序路径
// @gen_to: miniprogram

/** @type {(r: quan.DelMiniProgramPagePathReq, b: any) => Promise<quan.DelMiniProgramPagePathRsp>} TypeScript syntax */

export function DelMiniProgramPagePath(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelMiniProgramPagePath",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code

/** @type {(r: quan.CreateDeDupChannelLiveCodeReq, b: any) => Promise<quan.CreateDeDupChannelLiveCodeRsp>} TypeScript syntax */

export function CreateDeDupChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CreateDeDupChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code

/** @type {(r: quan.SetDeDupChannelLiveCodeReq, b: any) => Promise<quan.SetDeDupChannelLiveCodeRsp>} TypeScript syntax */

export function SetDeDupChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetDeDupChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code

/** @type {(r: quan.BatchDelDeDupChannelLiveCodeReq, b: any) => Promise<quan.BatchDelDeDupChannelLiveCodeRsp>} TypeScript syntax */

export function BatchDelDeDupChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDelDeDupChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code

/** @type {(r: quan.GetDeDupChannelLiveCodeListReq, b: any) => Promise<quan.GetDeDupChannelLiveCodeListRsp>} TypeScript syntax */

export function GetDeDupChannelLiveCodeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDeDupChannelLiveCodeList",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetDeDupChannelLiveCodeByOpenIdReq, b: any) => Promise<quan.GetDeDupChannelLiveCodeByOpenIdRsp>} TypeScript syntax */

export function GetDeDupChannelLiveCodeByOpenId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDeDupChannelLiveCodeByOpenId",
    "auth": "0"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code

/** @type {(r: quan.CheckExtContactInCorpReq, b: any) => Promise<quan.CheckExtContactInCorpRsp>} TypeScript syntax */

export function CheckExtContactInCorp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckExtContactInCorp",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code

/** @type {(r: quan.GetDeDupChannelLiveCodeReq, b: any) => Promise<quan.GetDeDupChannelLiveCodeRsp>} TypeScript syntax */

export function GetDeDupChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetDeDupChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: dedup_live_code

/** @type {(r: quan.BatchDownloadDeDupChannelLiveCodeReq, b: any) => Promise<quan.BatchDownloadDeDupChannelLiveCodeRsp>} TypeScript syntax */

export function BatchDownloadDeDupChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDownloadDeDupChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc: 获取联运渠道配置
// @gen: t=get_model
// @gen_to: combined_business
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCombinedBusinessAppReq, b: any) => Promise<quan.GetCombinedBusinessAppRsp>} TypeScript syntax */

export function GetCombinedBusinessApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCombinedBusinessApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 添加联运渠道配置
// @error:
// @gen: t=add_model
// @gen_to: combined_business
// svr options: (ext.UserType) = staff

/** @type {(r: quan.AddCombinedBusinessAppReq, b: any) => Promise<quan.AddCombinedBusinessAppRsp>} TypeScript syntax */

export function AddCombinedBusinessApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddCombinedBusinessApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取联运渠道配置列表
// @error:
// @gen: t=get_model_list
// @gen_to: combined_business
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCombinedBusinessAppListReq, b: any) => Promise<quan.GetCombinedBusinessAppListRsp>} TypeScript syntax */

export function GetCombinedBusinessAppList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCombinedBusinessAppList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 更新联运渠道配置
// @error:
// @gen: t=update_model
// @gen_to: combined_business
// svr options: (ext.UserType) = staff

/** @type {(r: quan.UpdateCombinedBusinessAppReq, b: any) => Promise<quan.UpdateCombinedBusinessAppRsp>} TypeScript syntax */

export function UpdateCombinedBusinessApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateCombinedBusinessApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 删除联运渠道配置
// @error:
// @gen: t=del_model
// @gen_to: combined_business
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelCombinedBusinessAppReq, b: any) => Promise<quan.DelCombinedBusinessAppRsp>} TypeScript syntax */

export function DelCombinedBusinessApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelCombinedBusinessApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 联运渠道用户授权方法
// @desc:
// @error:
// svr options: (ext.UserType) = account

/** @type {(r: quan.CombinedBusinessUserAuthReq, b: any) => Promise<quan.CombinedBusinessUserAuthRsp>} TypeScript syntax */

export function CombinedBusinessUserAuth(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CombinedBusinessUserAuth",
    "auth": "2"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取导出客户列表字段
// @error:
// @gen_to: export

/** @type {(r: quan.GetExtContactFollowFieldReq, b: any) => Promise<quan.GetExtContactFollowFieldRsp>} TypeScript syntax */

export function GetExtContactFollowField(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactFollowField",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 导出批量修改活码欢迎语失败记录
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: export

/** @type {(r: quan.ExportBatchSetWelcomeMsg4ChannelLiveCodeReq, b: any) => Promise<quan.ExportBatchSetWelcomeMsg4ChannelLiveCodeRsp>} TypeScript syntax */

export function ExportBatchSetWelcomeMsg4ChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportBatchSetWelcomeMsg4ChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: sync

/** @type {(r: quan.SyncContactsV2Req, b: any) => Promise<quan.SyncContactsV2Rsp>} TypeScript syntax */

export function SyncContactsV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncContactsV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 下载选择全部渠道活码记录
// @desc:
// @error:
// @gen_to: export

/** @type {(r: quan.BatchDownloadAllChannelLiveCodeReq, b: any) => Promise<quan.BatchDownloadAllChannelLiveCodeRsp>} TypeScript syntax */

export function BatchDownloadAllChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchDownloadAllChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 重试批量修改活码欢迎语失败的记录
// @desc:
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope 您已被移出应用可见范围
// @gen_to: live_code

/** @type {(r: quan.RetryBatchSetWelcomeMsg4ChannelLiveCodeReq, b: any) => Promise<quan.RetryBatchSetWelcomeMsg4ChannelLiveCodeRsp>} TypeScript syntax */

export function RetryBatchSetWelcomeMsg4ChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/RetryBatchSetWelcomeMsg4ChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc: 获取验证码时校验绑定手机号
// @error:

/** @type {(r: quan.SendVerifyCodeForBindPhoneNumberReq, b: any) => Promise<quan.SendVerifyCodeForBindPhoneNumberRsp>} TypeScript syntax */

export function SendVerifyCodeForBindPhoneNumber(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SendVerifyCodeForBindPhoneNumber",
    "auth": "1"
  }), o));
}
; // @desc: 绑定手机号
// @error:

/** @type {(r: quan.BindPhoneNumberReq, b: any) => Promise<quan.BindPhoneNumberRsp>} TypeScript syntax */

export function BindPhoneNumber(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BindPhoneNumber",
    "auth": "1"
  }), o));
}
; // @desc: 获取账号注册渠道来源
// @error:
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetAccountRegSourceListReq, b: any) => Promise<quan.GetAccountRegSourceListRsp>} TypeScript syntax */

export function GetAccountRegSourceList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAccountRegSourceList",
    "auth": "1"
  }), o));
}
; // @desc: 校验绑定手机号验证码
// @error:

/** @type {(r: quan.VerifyCode4BindPhoneNumberReq, b: any) => Promise<quan.VerifyCode4BindPhoneNumberRsp>} TypeScript syntax */

export function VerifyCode4BindPhoneNumber(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/VerifyCode4BindPhoneNumber",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetAdvanceExtContactResultAsyncV2Req, b: any) => Promise<quan.GetAdvanceExtContactResultAsyncV2Rsp>} TypeScript syntax */

export function GetAdvanceExtContactResultAsyncV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAdvanceExtContactResultAsyncV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取用户绑定的手机号码
// @error:

/** @type {(r: quan.GetUserBindingPhoneReq, b: any) => Promise<quan.GetUserBindingPhoneRsp>} TypeScript syntax */

export function GetUserBindingPhone(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserBindingPhone",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取企业的部门的父子关系map[WwDeptId]WwDeptParentId
// @error:
// @gen_to: dept

/** @type {(r: quan.GetCorpDeptMapReq, b: any) => Promise<quan.GetCorpDeptMapRsp>} TypeScript syntax */

export function GetCorpDeptMap(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpDeptMap",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取用户的企微部门ID
// @desc: 从 quan_user_dept 查询
// @error:
// @gen_to: dept

/** @type {(r: quan.GetUserDeptListReq, b: any) => Promise<quan.GetUserDeptListRsp>} TypeScript syntax */

export function GetUserDeptList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetUserDeptList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactListV2Req, b: any) => Promise<quan.GetExtContactListV2Rsp>} TypeScript syntax */

export function GetExtContactListV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactListV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.GenSpeechcraftShareCodeReq, b: any) => Promise<quan.GenSpeechcraftShareCodeRsp>} TypeScript syntax */

export function GenSpeechcraftShareCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GenSpeechcraftShareCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.RefreshSpeechcraftShareCodeReq, b: any) => Promise<quan.RefreshSpeechcraftShareCodeRsp>} TypeScript syntax */

export function RefreshSpeechcraftShareCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/RefreshSpeechcraftShareCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.ImportSpeechcraftShareCodeReq, b: any) => Promise<quan.ImportSpeechcraftShareCodeRsp>} TypeScript syntax */

export function ImportSpeechcraftShareCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ImportSpeechcraftShareCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.BatchAddSameTitleSpeechcraftReq, b: any) => Promise<quan.BatchAddSameTitleSpeechcraftRsp>} TypeScript syntax */

export function BatchAddSameTitleSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchAddSameTitleSpeechcraft",
    "auth": "1"
  }), o));
}
; // ErrUnsupportedAccountType 不支持的账号类型
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope
// @gen: t=get_model_list_db_proxy
// @gen_to: ext_contact_follow

/** @type {(r: quan.GetExtContactFollowListV2Req, b: any) => Promise<quan.GetExtContactFollowListV2Rsp>} TypeScript syntax */

export function GetExtContactFollowListV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactFollowListV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 当前登录的企业成员信息
// @desc: 圈量2.0
// @error:
// @gen_to: user

/** @type {(r: quan.GetBaseUserInfoReq, b: any) => Promise<quan.GetBaseUserInfoRsp>} TypeScript syntax */

export function GetBaseUserInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetBaseUserInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 设置账号默认登录的企业
// @desc: 圈量2.0
// @error:
// @gen_to: account

/** @type {(r: quan.SetAccountDefaultCorpReq, b: any) => Promise<quan.SetAccountDefaultCorpRsp>} TypeScript syntax */

export function SetAccountDefaultCorp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetAccountDefaultCorp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.CancelSpeechcraftShareCodeReq, b: any) => Promise<quan.CancelSpeechcraftShareCodeRsp>} TypeScript syntax */

export function CancelSpeechcraftShareCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CancelSpeechcraftShareCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.GetSpeechcraftShareCodeListReq, b: any) => Promise<quan.GetSpeechcraftShareCodeListRsp>} TypeScript syntax */

export function GetSpeechcraftShareCodeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSpeechcraftShareCodeList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactListKeyWithFilterAsyncReq, b: any) => Promise<quan.GetExtContactListKeyWithFilterAsyncRsp>} TypeScript syntax */

export function GetExtContactListKeyWithFilterAsync(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactListKeyWithFilterAsync",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.GetExtContactListWithCacheKeyReq, b: any) => Promise<quan.GetExtContactListWithCacheKeyRsp>} TypeScript syntax */

export function GetExtContactListWithCacheKey(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactListWithCacheKey",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.GetPersonalSpeechcraftListReq, b: any) => Promise<quan.GetPersonalSpeechcraftListRsp>} TypeScript syntax */

export function GetPersonalSpeechcraftList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetPersonalSpeechcraftList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.OrderSpeechcraftReq, b: any) => Promise<quan.OrderSpeechcraftRsp>} TypeScript syntax */

export function OrderSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/OrderSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 校验账号
// @desc: 圈量 2.0，用于修改密码、修改手机号
// @error:
// @gen_to: account

/** @type {(r: quan.ValidateAccountReq, b: any) => Promise<quan.ValidateAccountRsp>} TypeScript syntax */

export function ValidateAccount(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ValidateAccount",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 修改密码
// @desc: 圈量 2.0
// @error:
// @gen_to: account

/** @type {(r: quan.ModifyAccountPasswordReq, b: any) => Promise<quan.ModifyAccountPasswordRsp>} TypeScript syntax */

export function ModifyAccountPassword(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ModifyAccountPassword",
    "auth": "1"
  }), o));
}
; // @name: 修改手机号
// @desc: 圈量 2.0
// @gen_to: account

/** @type {(r: quan.ModifyAccountPhoneReq, b: any) => Promise<quan.ModifyAccountPhoneRsp>} TypeScript syntax */

export function ModifyAccountPhone(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ModifyAccountPhone",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取平台通知列表
// @desc: 圈量 2.0
// @error:
// @gen_to: plat_notice

/** @type {(r: quan.GetPlatNoticeListReq, b: any) => Promise<quan.GetPlatNoticeListRsp>} TypeScript syntax */

export function GetPlatNoticeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetPlatNoticeList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取平台通知内容
// @desc: 圈量 2.0
// @error:
// @gen_to: plat_notice

/** @type {(r: quan.GetPlatNoticeContentReq, b: any) => Promise<quan.GetPlatNoticeContentRsp>} TypeScript syntax */

export function GetPlatNoticeContent(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetPlatNoticeContent",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 读取平台通知
// @desc: 圈量 2.0
// @error:
// @gen_to: plat_notice

/** @type {(r: quan.ReadPlatNoticeReq, b: any) => Promise<quan.ReadPlatNoticeRsp>} TypeScript syntax */

export function ReadPlatNotice(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ReadPlatNotice",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 通知红点信息
// @desc: 圈量 2.0
// @error:
// @gen_to: plat_notice

/** @type {(r: quan.NoticeRedPointReq, b: any) => Promise<quan.NoticeRedPointRsp>} TypeScript syntax */

export function NoticeRedPoint(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/NoticeRedPoint",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取最新的公告信息
// @desc: 圈量 2.0
// @error:
// @gen_to: plat_notice

/** @type {(r: quan.GetLatestPlatNoticeReq, b: any) => Promise<quan.GetLatestPlatNoticeRsp>} TypeScript syntax */

export function GetLatestPlatNotice(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetLatestPlatNotice",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.BatchSetSameTitleSpeechcraftReq, b: any) => Promise<quan.BatchSetSameTitleSpeechcraftRsp>} TypeScript syntax */

export function BatchSetSameTitleSpeechcraft(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetSameTitleSpeechcraft",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 账号绑定企业成员
// @desc: 圈量 2.0
// @error:
// @gen_to: account

/** @type {(r: quan.AccountBindUserReq, b: any) => Promise<quan.AccountBindUserRsp>} TypeScript syntax */

export function AccountBindUser(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AccountBindUser",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 账号授权app
// @desc: 圈量 2.0
// @error:
// @gen_to: account

/** @type {(r: quan.AccountAuthAppReq, b: any) => Promise<quan.AccountAuthAppRsp>} TypeScript syntax */

export function AccountAuthApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AccountAuthApp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUserNotInAuthAppScope
// ErrMaterialNotFound
// ErrCorpNotAuth
// @gen_to: speechcraft

/** @type {(r: quan.UploadSpeechcraftFileContent2WwMediaReq, b: any) => Promise<quan.UploadSpeechcraftFileContent2WwMediaRsp>} TypeScript syntax */

export function UploadSpeechcraftFileContent2WwMedia(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UploadSpeechcraftFileContent2WwMedia",
    "auth": "1"
  }), o));
}
; // @desc:

/** @type {(r: quan.GetCorpStatV2Req, b: any) => Promise<quan.GetCorpStatV2Rsp>} TypeScript syntax */

export function GetCorpStatV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpStatV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 账号解绑企微
// @desc: 圈量 2.0
// @error:
// @gen_to: account

/** @type {(r: quan.UnbindAccountCorpV2Req, b: any) => Promise<quan.UnbindAccountCorpV2Rsp>} TypeScript syntax */

export function UnbindAccountCorpV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UnbindAccountCorpV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取应用可见范围
// @error:
// @gen_to: app

/** @type {(r: quan.GetAppScopeReq, b: any) => Promise<quan.GetAppScopeRsp>} TypeScript syntax */

export function GetAppScope(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAppScope",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.GetSpeechcraftShareCodeReq, b: any) => Promise<quan.GetSpeechcraftShareCodeRsp>} TypeScript syntax */

export function GetSpeechcraftShareCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSpeechcraftShareCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: speechcraft

/** @type {(r: quan.UpdateSpeechcraftTitleViewOrderReq, b: any) => Promise<quan.UpdateSpeechcraftTitleViewOrderRsp>} TypeScript syntax */

export function UpdateSpeechcraftTitleViewOrder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateSpeechcraftTitleViewOrder",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model
// @gen_to: speechcraft

/** @type {(r: quan.GetSpeechcraftTitleReq, b: any) => Promise<quan.GetSpeechcraftTitleRsp>} TypeScript syntax */

export function GetSpeechcraftTitle(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSpeechcraftTitle",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetAdvertConfigReq, b: any) => Promise<quan.SetAdvertConfigRsp>} TypeScript syntax */

export function SetAdvertConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetAdvertConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetAdvertConfigReq, b: any) => Promise<quan.GetAdvertConfigRsp>} TypeScript syntax */

export function GetAdvertConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAdvertConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: quan.GetRoleAllowDeptAndMemberListReq, b: any) => Promise<quan.GetRoleAllowDeptAndMemberListRsp>} TypeScript syntax */

export function GetRoleAllowDeptAndMemberList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRoleAllowDeptAndMemberList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: quan.SyncResignedStaffExtContactTransferResultReq, b: any) => Promise<quan.SyncResignedStaffExtContactTransferResultRsp>} TypeScript syntax */

export function SyncResignedStaffExtContactTransferResult(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncResignedStaffExtContactTransferResult",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @deprecated 改用 StaffLoginQuanV2

/** @type {(r: quan.StaffLoginQuanV2AsCorpCreatorReq, b: any) => Promise<quan.StaffLoginQuanV2AsCorpCreatorRsp>} TypeScript syntax */

export function StaffLoginQuanV2AsCorpCreator(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/StaffLoginQuanV2AsCorpCreator",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 运营后台登录圈2.0
// @desc:
// @error:

/** @type {(r: quan.StaffLoginQuanV2Req, b: any) => Promise<quan.StaffLoginQuanV2Rsp>} TypeScript syntax */

export function StaffLoginQuanV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/StaffLoginQuanV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: op
// svr options: (ext.UserType) = staff

/** @type {(r: quan.DelPermissionByIdsReq, b: any) => Promise<quan.DelPermissionByIdsRsp>} TypeScript syntax */

export function DelPermissionByIds(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelPermissionByIds",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 批量编辑渠道活码成员
// Deprecated 设计有问题，请不要使用
// @error:
// @gen_to: live_code

/** @type {(r: quan.BatchSetUser4ChannelLiveCodeReq, b: any) => Promise<quan.BatchSetUser4ChannelLiveCodeRsp>} TypeScript syntax */

export function BatchSetUser4ChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetUser4ChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 设置企业对外展示名称
// @desc:
// @error:
// @gen_to: corp
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetCorpAliasNameReq, b: any) => Promise<quan.SetCorpAliasNameRsp>} TypeScript syntax */

export function SetCorpAliasName(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCorpAliasName",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 客户投诉添加
// @desc:
// @error:
// @gen_to: customer_complaint
// svr options: (ext.UserType) = pub

/** @type {(r: quan.AddCustomerComplaintReq, b: any) => Promise<quan.AddCustomerComplaintRsp>} TypeScript syntax */

export function AddCustomerComplaint(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddCustomerComplaint",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: smq.ConsumeReq, b: any) => Promise<smq.ConsumeRsp>} TypeScript syntax */

export function SyncExtContactPhoneListMq(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncExtContactPhoneListMq",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:线索管理V2
// @desc: 已过时.........
// @error:
// @gen_to: auth

/** @type {(r: quan.GetAccountListV2Req, b: any) => Promise<quan.GetAccountListV2Rsp>} TypeScript syntax */

export function GetAccountListV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAccountListV2",
    "auth": "1"
  }), o));
}
; // @cat: 企业管理-系统配置
// @name: 设置企业基础信息配置
// @desc:
// @error:
// ErrExtContactSecretIncorrect
// ErrContactSecretIncorrect
// @gen_to: config

/** @type {(r: quan.SetCorpBaseInfoConfigReq, b: any) => Promise<quan.SetCorpBaseInfoConfigRsp>} TypeScript syntax */

export function SetCorpBaseInfoConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCorpBaseInfoConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: export

/** @type {(r: quan.ExportChannelLiveCodeListReq, b: any) => Promise<quan.ExportChannelLiveCodeListRsp>} TypeScript syntax */

export function ExportChannelLiveCodeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportChannelLiveCodeList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 渠道活码批量单人添加-添加结果导出Excel
// @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.AddChannelLiveCode4BatchSingleBeExportReq, b: any) => Promise<quan.AddChannelLiveCode4BatchSingleBeExportRsp>} TypeScript syntax */

export function AddChannelLiveCode4BatchSingleBeExport(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddChannelLiveCode4BatchSingleBeExport",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: smq.ConsumeReq, b: any) => Promise<smq.ConsumeRsp>} TypeScript syntax */

export function HandleAddExtContactCallbackMq(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/HandleAddExtContactCallbackMq",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: smq.ConsumeReq, b: any) => Promise<smq.ConsumeRsp>} TypeScript syntax */

export function HandleSetExtContactCallbackMq(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/HandleSetExtContactCallbackMq",
    "auth": "1"
  }), o));
}
; // @desc: 成员发送详情导出
// @error:
// @gen_to: export

/** @type {(r: quan.ExportExtContactBatchSendStaffListReq, b: any) => Promise<quan.ExportExtContactBatchSendStaffListRsp>} TypeScript syntax */

export function ExportExtContactBatchSendStaffList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportExtContactBatchSendStaffList",
    "auth": "1"
  }), o));
}
; // @name: 客户送达详情导出
// @desc:
// @error:
// @gen_to: export

/** @type {(r: quan.ExportExtContactBatchSendExtListReq, b: any) => Promise<quan.ExportExtContactBatchSendExtListRsp>} TypeScript syntax */

export function ExportExtContactBatchSendExtList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportExtContactBatchSendExtList",
    "auth": "1"
  }), o));
}
; // @name: 批量删除渠道活码
// @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.BatchReleaseChannelLiveCodeReq, b: any) => Promise<quan.BatchReleaseChannelLiveCodeRsp>} TypeScript syntax */

export function BatchReleaseChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchReleaseChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @name: 批量删除去重渠道活码
// @desc:
// @error:
// @gen_to: dedup_live_code

/** @type {(r: quan.BatchReleaseDeDupChannelLiveCodeReq, b: any) => Promise<quan.BatchReleaseDeDupChannelLiveCodeRsp>} TypeScript syntax */

export function BatchReleaseDeDupChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchReleaseDeDupChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:获取群主、分类及其分类关系
// @error:
// @gen_to: chat

/** @type {(r: quan.GetGroupChatOwnerCategoryReq, b: any) => Promise<quan.GetGroupChatOwnerCategoryRsp>} TypeScript syntax */

export function GetGroupChatOwnerCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetGroupChatOwnerCategory",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen_to: live_code
// @gen: corp=head'

/** @type {(r: quan.BatchSetUser4ChannelLiveCodeV2Req, b: any) => Promise<quan.BatchSetUser4ChannelLiveCodeV2Rsp>} TypeScript syntax */

export function BatchSetUser4ChannelLiveCodeV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetUser4ChannelLiveCodeV2",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen_to: ext_contact

/** @type {(r: quan.SyncExtContactByExtUserIdSysReq, b: any) => Promise<quan.SyncExtContactByExtUserIdSysRsp>} TypeScript syntax */

export function SyncExtContactByExtUserIdSys(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncExtContactByExtUserIdSys",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:

/** @type {(r: quan.GetLicenseUserNumberReq, b: any) => Promise<quan.GetLicenseUserNumberRsp>} TypeScript syntax */

export function GetLicenseUserNumber(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetLicenseUserNumber",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:

/** @type {(r: schedulerv2.SchedulerCallbackReq, b: any) => Promise<schedulerv2.SchedulerCallbackRsp>} TypeScript syntax */

export function ScheduleHandleCreateAuthForCustomizeApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ScheduleHandleCreateAuthForCustomizeApp",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen_to: user

/** @type {(r: quan.UpdateUserLastShowLicenseAtReq, b: any) => Promise<quan.UpdateUserLastShowLicenseAtRsp>} TypeScript syntax */

export function UpdateUserLastShowLicenseAt(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateUserLastShowLicenseAt",
    "auth": "1"
  }), o));
}
; // @desc: 检查UidList 是否有未授权账号的
// @error:
// @gen_to: user

/** @type {(r: quan.CheckUidList4AuthLicenseReq, b: any) => Promise<quan.CheckUidList4AuthLicenseRsp>} TypeScript syntax */

export function CheckUidList4AuthLicense(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckUidList4AuthLicense",
    "auth": "1"
  }), o));
}
; // @desc: 导出成员列表
// @error:
// @gen_to: user

/** @type {(r: quan.ExportUserListReq, b: any) => Promise<quan.ExportUserListRsp>} TypeScript syntax */

export function ExportUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportUserList",
    "auth": "1"
  }), o));
}
; // @desc: 成员批量绑定手机号
// @error:
// @gen_to: user

/** @type {(r: quan.ImportExcel4BatchUserBindPhoneNumberListReq, b: any) => Promise<quan.ImportExcel4BatchUserBindPhoneNumberListRsp>} TypeScript syntax */

export function ImportExcel4BatchUserBindPhoneNumberList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ImportExcel4BatchUserBindPhoneNumberList",
    "auth": "1"
  }), o));
}
; // @desc: 前置检查成员批量绑定手机号
// @error:
// @gen_to: user

/** @type {(r: quan.CheckExcel4ModifyUserBindPhoneNumberListReq, b: any) => Promise<quan.CheckExcel4ModifyUserBindPhoneNumberListRsp>} TypeScript syntax */

export function CheckExcel4ModifyUserBindPhoneNumberList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckExcel4ModifyUserBindPhoneNumberList",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetRegisterFeatureFlagConfigReq, b: any) => Promise<quan.GetRegisterFeatureFlagConfigRsp>} TypeScript syntax */

export function GetRegisterFeatureFlagConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRegisterFeatureFlagConfig",
    "auth": "0"
  }), o));
}
; // @desc:
// @gen_to: customized_app

/** @type {(r: quan.GetCustomizedTplAuthQrCodeV2Req, b: any) => Promise<quan.GetCustomizedTplAuthQrCodeV2Rsp>} TypeScript syntax */

export function GetCustomizedTplAuthQrCodeV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCustomizedTplAuthQrCodeV2",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: config
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetNotLoginStyleReq, b: any) => Promise<quan.GetNotLoginStyleRsp>} TypeScript syntax */

export function GetNotLoginStyle(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetNotLoginStyle",
    "auth": "0"
  }), o));
}
; // @desc:
// @gen_to: customized_app

/** @type {(r: quan.CheckCustomizedAppInstallResultReq, b: any) => Promise<quan.CheckCustomizedAppInstallResultRsp>} TypeScript syntax */

export function CheckCustomizedAppInstallResult(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckCustomizedAppInstallResult",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:

/** @type {(r: quan.VerifyUserToBindAccountv2Req, b: any) => Promise<quan.VerifyUserToBindAccountv2Rsp>} TypeScript syntax */

export function VerifyUserToBindAccountv2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/VerifyUserToBindAccountv2",
    "auth": "1"
  }), o));
}
; // @name: 发送导出相关的短信验证码
// @desc:
// @gen_to: export

/** @type {(r: quan.SendExportVerifyCodeReq, b: any) => Promise<quan.SendExportVerifyCodeRsp>} TypeScript syntax */

export function SendExportVerifyCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SendExportVerifyCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:

/** @type {(r: quan.GetAuthUserSensitiveH5UrlReq, b: any) => Promise<quan.GetAuthUserSensitiveH5UrlRsp>} TypeScript syntax */

export function GetAuthUserSensitiveH5Url(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetAuthUserSensitiveH5Url",
    "auth": "1"
  }), o));
}
; // @gen_to: export

/** @type {(r: quan.CheckExportVerifyCodeReq, b: any) => Promise<quan.CheckExportVerifyCodeRsp>} TypeScript syntax */

export function CheckExportVerifyCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckExportVerifyCode",
    "auth": "1"
  }), o));
}
; // @desc: 获取圈量版本列表
// @gen_to: version_mgr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetSysVersionListStaffReq, b: any) => Promise<quan.GetSysVersionListStaffRsp>} TypeScript syntax */

export function GetSysVersionListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSysVersionListStaff",
    "auth": "1"
  }), o));
}
; // @desc: 创建圈量版本
// @gen_to: version_mgr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.CreateSysVersionStaffReq, b: any) => Promise<quan.CreateSysVersionStaffRsp>} TypeScript syntax */

export function CreateSysVersionStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CreateSysVersionStaff",
    "auth": "1"
  }), o));
}
; // @desc: 修改圈量版本
// @gen_to: version_mgr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.UpdateSysVersionStaffReq, b: any) => Promise<quan.UpdateSysVersionStaffRsp>} TypeScript syntax */

export function UpdateSysVersionStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateSysVersionStaff",
    "auth": "1"
  }), o));
}
; // @desc: 设置圈量版本是否默认使用
// @gen_to: version_mgr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.ToggleSysVersionStateStaffReq, b: any) => Promise<quan.ToggleSysVersionStateStaffRsp>} TypeScript syntax */

export function ToggleSysVersionStateStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ToggleSysVersionStateStaff",
    "auth": "1"
  }), o));
}
; // @desc: 获取圈量版本详情
// @gen_to: version_mgr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetSysVersionStaffReq, b: any) => Promise<quan.GetSysVersionStaffRsp>} TypeScript syntax */

export function GetSysVersionStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetSysVersionStaff",
    "auth": "1"
  }), o));
}
; // @desc:
// @error:
// @gen_to: live_code

/** @type {(r: quan.GetChannelLiveCodeForH5Req, b: any) => Promise<quan.GetChannelLiveCodeForH5Rsp>} TypeScript syntax */

export function GetChannelLiveCodeForH5(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannelLiveCodeForH5",
    "auth": "1"
  }), o));
}
; // @desc: 小程序、公众号绑定业务
// @error:
// @gen_to: wechat

/** @type {(r: quan.WxAppBindBizReq, b: any) => Promise<quan.WxAppBindBizRsp>} TypeScript syntax */

export function WxAppBindBiz(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/WxAppBindBiz",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取小程序、公众号绑定业务
// @error:
// @gen_to: wechat

/** @type {(r: quan.GetWxAppBindBizReq, b: any) => Promise<quan.GetWxAppBindBizRsp>} TypeScript syntax */

export function GetWxAppBindBiz(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWxAppBindBiz",
    "auth": "1"
  }), o));
}
; // @desc: 获取小程序、公众号绑定业务
// @gen_to: wechat

/** @type {(r: quan.GetWxAppBindBizSysReq, b: any) => Promise<quan.GetWxAppBindBizSysRsp>} TypeScript syntax */

export function GetWxAppBindBizSys(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWxAppBindBizSys",
    "auth": "1"
  }), o));
}
; // @desc: 小程序、公众号绑定业务
// @gen_to: wechat

/** @type {(r: quan.GenerateShortLinkReq, b: any) => Promise<quan.GenerateShortLinkRsp>} TypeScript syntax */

export function GenerateShortLink(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GenerateShortLink",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: wechat

/** @type {(r: quan.GenerateQrcodeReq, b: any) => Promise<quan.GenerateQrcodeRsp>} TypeScript syntax */

export function GenerateQrcode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GenerateQrcode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: quan.AddWxAppWebviewDomainReq, b: any) => Promise<quan.AddWxAppWebviewDomainRsp>} TypeScript syntax */

export function AddWxAppWebviewDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddWxAppWebviewDomain",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: quan.UpdateWechatUserInfoWxReq, b: any) => Promise<quan.UpdateWechatUserInfoWxRsp>} TypeScript syntax */

export function UpdateWechatUserInfoWx(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateWechatUserInfoWx",
    "auth": "1"
  }), o));
}
; // @desc: 圈量版本排序
// @gen_to: version_mgr
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SortSysVersionReq, b: any) => Promise<quan.SortSysVersionRsp>} TypeScript syntax */

export function SortSysVersion(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SortSysVersion",
    "auth": "1"
  }), o));
}
; // @desc: 用于小程序上线模板审核 展示不同商品
// @gen_to: wechat
// svr options: (ext.UserType) = pub

/** @type {(r: quan.IsMpVersionOnlineReq, b: any) => Promise<quan.IsMpVersionOnlineRsp>} TypeScript syntax */

export function IsMpVersionOnline(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/IsMpVersionOnline",
    "auth": "0"
  }), o));
}
; // @desc:
// @error:

/** @type {(r: quan.UpdateWxUserMobileReq, b: any) => Promise<quan.UpdateWxUserMobileRsp>} TypeScript syntax */

export function UpdateWxUserMobile(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateWxUserMobile",
    "auth": "1"
  }), o));
}
; // @desc: 水印设置
// @gen_to: watermark_setting
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetWatermarkSettingReq, b: any) => Promise<quan.GetWatermarkSettingRsp>} TypeScript syntax */

export function GetWatermarkSetting(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetWatermarkSetting",
    "auth": "0"
  }), o));
}
; // @desc: 水印设置
// @gen_to: watermark_setting

/** @type {(r: quan.SetWatermarkSettingReq, b: any) => Promise<quan.SetWatermarkSettingRsp>} TypeScript syntax */

export function SetWatermarkSetting(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetWatermarkSetting",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: material

/** @type {(r: quan.BatchUpdateMaterialCategoryReq, b: any) => Promise<quan.BatchUpdateMaterialCategoryRsp>} TypeScript syntax */

export function BatchUpdateMaterialCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchUpdateMaterialCategory",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: material

/** @type {(r: quan.GetMaterialCategoryPermReq, b: any) => Promise<quan.GetMaterialCategoryPermRsp>} TypeScript syntax */

export function GetMaterialCategoryPerm(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetMaterialCategoryPerm",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: auth

/** @type {(r: schedulerv2.SchedulerCallbackReq, b: any) => Promise<schedulerv2.SchedulerCallbackRsp>} TypeScript syntax */

export function SchedTrySyncCorpTrialTime(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SchedTrySyncCorpTrialTime",
    "auth": "1"
  }), o));
}
; // @desc: 批量设置去重渠道活码
// @gen_to: dedup_live_code

/** @type {(r: quan.BatchSetDeDupChannelLiveCodeReq, b: any) => Promise<quan.BatchSetDeDupChannelLiveCodeRsp>} TypeScript syntax */

export function BatchSetDeDupChannelLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/BatchSetDeDupChannelLiveCode",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: wechat
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetFeatByWxAppReq, b: any) => Promise<quan.GetFeatByWxAppRsp>} TypeScript syntax */

export function GetFeatByWxApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetFeatByWxApp",
    "auth": "0"
  }), o));
}
; // @desc:  运营后台调用，获取企业区域配置
// @gen_to: region_config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCorpRegionConfigListStaffReq, b: any) => Promise<quan.GetCorpRegionConfigListStaffRsp>} TypeScript syntax */

export function GetCorpRegionConfigListStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpRegionConfigListStaff",
    "auth": "1"
  }), o));
}
; // @desc:  运营后台调用，设置通道区域配置
// @gen_to: region_config
// svr options: (ext.UserType) = staff

/** @type {(r: quan.SetCorpRegionConfigStaffReq, b: any) => Promise<quan.SetCorpRegionConfigStaffRsp>} TypeScript syntax */

export function SetCorpRegionConfigStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetCorpRegionConfigStaff",
    "auth": "1"
  }), o));
}
; // @desc: 前端调用，获取通道二维码，指定地区
// @gen_to: region_config

/** @type {(r: quan.GetChannelRegionListReq, b: any) => Promise<quan.GetChannelRegionListRsp>} TypeScript syntax */

export function GetChannelRegionList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetChannelRegionList",
    "auth": "1"
  }), o));
}
; // @desc: 添加通知组
// @gen_to: notify_group

/** @type {(r: quan.AddNotifyGroupReq, b: any) => Promise<quan.AddNotifyGroupRsp>} TypeScript syntax */

export function AddNotifyGroup(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AddNotifyGroup",
    "auth": "1"
  }), o));
}
; // @desc: 修改通知组
// @gen_to: notify_group

/** @type {(r: quan.UpdateNotifyGroupReq, b: any) => Promise<quan.UpdateNotifyGroupRsp>} TypeScript syntax */

export function UpdateNotifyGroup(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/UpdateNotifyGroup",
    "auth": "1"
  }), o));
}
; // @desc: 删除通知组
// @gen_to: notify_group

/** @type {(r: quan.DeleteNotifyGroupReq, b: any) => Promise<quan.DeleteNotifyGroupRsp>} TypeScript syntax */

export function DeleteNotifyGroup(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DeleteNotifyGroup",
    "auth": "1"
  }), o));
}
; // @desc: 获取通知组
// @gen_to: notify_group

/** @type {(r: quan.GetNotifyGroupReq, b: any) => Promise<quan.GetNotifyGroupRsp>} TypeScript syntax */

export function GetNotifyGroup(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetNotifyGroup",
    "auth": "1"
  }), o));
}
; // @desc: 获取通知组列表
// @gen_to: notify_group

/** @type {(r: quan.GetNotifyGroupListReq, b: any) => Promise<quan.GetNotifyGroupListRsp>} TypeScript syntax */

export function GetNotifyGroupList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetNotifyGroupList",
    "auth": "1"
  }), o));
}
; // @desc: 获取通知公众号二维码
// @gen_to: notify_group

/** @type {(r: quan.GetNotifyOfficialAccountsQrcodeReq, b: any) => Promise<quan.GetNotifyOfficialAccountsQrcodeRsp>} TypeScript syntax */

export function GetNotifyOfficialAccountsQrcode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetNotifyOfficialAccountsQrcode",
    "auth": "1"
  }), o));
}
; // @desc: 通知公众号回调
// @gen_to: notify_group
// svr options: (ext.UserType) = pub

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function NotifyOfficialAccountsCallback(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/NotifyOfficialAccountsCallback",
    "auth": "0"
  }), o));
}
; // @desc: 通知组用户绑定
// @gen_to: notify_group
// svr options: (ext.UserType) = pub

/** @type {(r: quan.NotifyGroupUserBindReq, b: any) => Promise<quan.NotifyGroupUserBindRsp>} TypeScript syntax */

export function NotifyGroupUserBind(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/NotifyGroupUserBind",
    "auth": "0"
  }), o));
}
; // @desc: 获取通知组用户信息
// @gen_to: notify_group
// svr options: (ext.UserType) = pub

/** @type {(r: quan.NotifyGroupUserInfoReq, b: any) => Promise<quan.NotifyGroupUserInfoRsp>} TypeScript syntax */

export function NotifyGroupUserInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/NotifyGroupUserInfo",
    "auth": "0"
  }), o));
}
; // @desc: 通知组用户解绑
// @gen_to: notify_group
// svr options: (ext.UserType) = pub

/** @type {(r: quan.NotifyGroupUserUnbindReq, b: any) => Promise<quan.NotifyGroupUserUnbindRsp>} TypeScript syntax */

export function NotifyGroupUserUnbind(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/NotifyGroupUserUnbind",
    "auth": "0"
  }), o));
}
; // @name: 同步增量好友
// @desc: 对比本地数据库的成员下企微好友ID，补充缺失的好友关系数据
// @error:
// ErrCorpNotAuth
// ErrUserNotInAuthAppScope

/** @type {(r: quan.SyncLackExtContactReq, b: any) => Promise<quan.SyncLackExtContactRsp>} TypeScript syntax */

export function SyncLackExtContact(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncLackExtContact",
    "auth": "1"
  }), o));
}
; // @desc: h5获取通知列表
// @gen_to: notify_group
// svr options: (ext.UserType) = pub

/** @type {(r: quan.GetNotifyGroupContentListReq, b: any) => Promise<quan.GetNotifyGroupContentListRsp>} TypeScript syntax */

export function GetNotifyGroupContentList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetNotifyGroupContentList",
    "auth": "0"
  }), o));
}
; // @desc: 暂停循环任务
// @gen_to: ext_contact_batch_send

/** @type {(r: quan.PauseExtContactBatchSendTaskReq, b: any) => Promise<quan.PauseExtContactBatchSendTaskRsp>} TypeScript syntax */

export function PauseExtContactBatchSendTask(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/PauseExtContactBatchSendTask",
    "auth": "1"
  }), o));
}
; // @desc: 开启循环任务
// @gen_to: ext_contact_batch_send

/** @type {(r: quan.ContinueExtContactBatchSendTaskReq, b: any) => Promise<quan.ContinueExtContactBatchSendTaskRsp>} TypeScript syntax */

export function ContinueExtContactBatchSendTask(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ContinueExtContactBatchSendTask",
    "auth": "1"
  }), o));
}
; // @desc: 删除群发任务
// @gen_to: ext_contact_batch_send

/** @type {(r: quan.DelExtContactBatchSendTaskReq, b: any) => Promise<quan.DelExtContactBatchSendTaskRsp>} TypeScript syntax */

export function DelExtContactBatchSendTask(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/DelExtContactBatchSendTask",
    "auth": "1"
  }), o));
}
; // @desc: 终止群发任务
// @gen_to: ext_contact_batch_send

/** @type {(r: quan.AbortExtContactBatchSendTaskReq, b: any) => Promise<quan.AbortExtContactBatchSendTaskRsp>} TypeScript syntax */

export function AbortExtContactBatchSendTask(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/AbortExtContactBatchSendTask",
    "auth": "1"
  }), o));
}
; // @desc: 获取群发任务变更记录列表
// @gen_to: ext_contact_batch_send

/** @type {(r: quan.GetExtContactBatchSendTaskChangedLogListReq, b: any) => Promise<quan.GetExtContactBatchSendTaskChangedLogListRsp>} TypeScript syntax */

export function GetExtContactBatchSendTaskChangedLogList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactBatchSendTaskChangedLogList",
    "auth": "1"
  }), o));
}
; // @desc: 同步群发任务结果
// @gen_to: ext_contact_batch_send

/** @type {(r: quan.SyncExtContactBatchSendTaskResultReq, b: any) => Promise<quan.SyncExtContactBatchSendTaskResultRsp>} TypeScript syntax */

export function SyncExtContactBatchSendTaskResult(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SyncExtContactBatchSendTaskResult",
    "auth": "1"
  }), o));
}
; // @desc: 导出渠道列表
// @gen_to: channel

/** @type {(r: quan.ExportChannelListReq, b: any) => Promise<quan.ExportChannelListRsp>} TypeScript syntax */

export function ExportChannelList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportChannelList",
    "auth": "1"
  }), o));
}
; // @desc: 导入渠道列表
// @gen_to: channel

/** @type {(r: quan.ImportChannelListReq, b: any) => Promise<quan.ImportChannelListRsp>} TypeScript syntax */

export function ImportChannelList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ImportChannelList",
    "auth": "1"
  }), o));
}
; // @desc: 导入渠道列表前置校验
// @gen_to: channel

/** @type {(r: quan.CheckExcel4ImportChannelListReq, b: any) => Promise<quan.CheckExcel4ImportChannelListRsp>} TypeScript syntax */

export function CheckExcel4ImportChannelList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckExcel4ImportChannelList",
    "auth": "1"
  }), o));
}
; // @desc: 导入去重渠道列表前置校验
// @gen_to: dedup_live_code

/** @type {(r: quan.CheckExcel4ImportDeDupLiveCodeListReq, b: any) => Promise<quan.CheckExcel4ImportDeDupLiveCodeListRsp>} TypeScript syntax */

export function CheckExcel4ImportDeDupLiveCodeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/CheckExcel4ImportDeDupLiveCodeList",
    "auth": "1"
  }), o));
}
; // @desc: 导入去重渠道列表
// @gen_to: dedup_live_code

/** @type {(r: quan.ImportDeDupLiveCodeListReq, b: any) => Promise<quan.ImportDeDupLiveCodeListRsp>} TypeScript syntax */

export function ImportDeDupLiveCodeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ImportDeDupLiveCodeList",
    "auth": "1"
  }), o));
}
; // @desc: 导出去重渠道列表
// @gen_to: dedup_live_code

/** @type {(r: quan.ExportDeDupLiveCodeListReq, b: any) => Promise<quan.ExportDeDupLiveCodeListRsp>} TypeScript syntax */

export function ExportDeDupLiveCodeList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/ExportDeDupLiveCodeList",
    "auth": "1"
  }), o));
}
; // @desc: 获取群发任务变更记录详情
// @gen_to: ext_contact_batch_send

/** @type {(r: quan.GetExtContactBatchSendTaskChangedLogReq, b: any) => Promise<quan.GetExtContactBatchSendTaskChangedLogRsp>} TypeScript syntax */

export function GetExtContactBatchSendTaskChangedLog(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetExtContactBatchSendTaskChangedLog",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 根据企业获取群开通数量配置
// @desc:
// @error:

/** @type {(r: quan.GetGroupNumConfigByCorpIdReq, b: any) => Promise<quan.GetGroupNumConfigByCorpIdRsp>} TypeScript syntax */

export function GetCorpGroupNumConfigByCorpId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCorpGroupNumConfigByCorpId",
    "auth": "1"
  }), o));
}
; // @desc:
// @gen_to: customized_app
// svr options: (ext.UserType) = staff

/** @type {(r: quan.GetCustomizedTplAuthQrCodeStaffReq, b: any) => Promise<quan.GetCustomizedTplAuthQrCodeStaffRsp>} TypeScript syntax */

export function GetCustomizedTplAuthQrCodeStaff(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetCustomizedTplAuthQrCodeStaff",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取群开通数量配置列表
// @desc:
// @error:

/** @type {(r: quan.GetNormalRobotGroupNumConfigListReq, b: any) => Promise<quan.GetNormalRobotGroupNumConfigListRsp>} TypeScript syntax */

export function GetNormalRobotGroupNumConfigList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetNormalRobotGroupNumConfigList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取群开通数量配置列表
// @desc:
// @error:

/** @type {(r: quan.GetRobotGroupNumConfigListReq, b: any) => Promise<quan.GetRobotGroupNumConfigListRsp>} TypeScript syntax */

export function GetRobotGroupNumConfigList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/GetRobotGroupNumConfigList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 添加或者设置机器人维度群开通数量配置列表
// @desc:
// @error:

/** @type {(r: quan.SetRobotGroupNumConfigReq, b: any) => Promise<quan.SetRobotGroupNumConfigRsp>} TypeScript syntax */

export function SetRobotGroupNumConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/SetRobotGroupNumConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 是否可以操作渠道活码
// @desc:
// @error: live_code

/** @type {(r: quan.IsAllowSetLiveCodeReq, b: any) => Promise<quan.IsAllowSetLiveCodeRsp>} TypeScript syntax */

export function IsAllowSetLiveCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/quan/IsAllowSetLiveCode",
    "auth": "1"
  }), o));
}
;
var QuanServices = {
  GetExtContactStat: GetExtContactStat,
  GetCustomizedTplAuthQrCode: GetCustomizedTplAuthQrCode,
  GetCorpCustomizedAppList: GetCorpCustomizedAppList,
  GetAccountCategory: GetAccountCategory,
  GetPreAuthCode: GetPreAuthCode,
  HandleAuth: HandleAuth,
  GetScanLoginInfo: GetScanLoginInfo,
  ScanLogin: ScanLogin,
  GetUserList: GetUserList,
  OpUser: OpUser,
  StatUserCountByRole: StatUserCountByRole,
  SyncContacts: SyncContacts,
  GetAppScopeNotMatchUserCount: GetAppScopeNotMatchUserCount,
  GetExtContactFollowList: GetExtContactFollowList,
  GetUserList4Selector: GetUserList4Selector,
  GetExtContact: GetExtContact,
  SetCorpTag: SetCorpTag,
  GetOperLogList: GetOperLogList,
  BatchSetCorpTag2Follow: BatchSetCorpTag2Follow,
  GetDupExtContactFollowList: GetDupExtContactFollowList,
  GetUserAttrDefList: GetUserAttrDefList,
  AddUserAttrDef: AddUserAttrDef,
  DelUserAttrDef: DelUserAttrDef,
  SetUserAttrDef: SetUserAttrDef,
  SetUserAttrDef4Sys: SetUserAttrDef4Sys,
  SetExtContactAttr: SetExtContactAttr,
  GetExtContactAttr: GetExtContactAttr,
  AddExtContactBatchSend: AddExtContactBatchSend,
  GetExtContactBatchSend: GetExtContactBatchSend,
  GetExtContactBatchSendList: GetExtContactBatchSendList,
  CountExtContactBatchSend: CountExtContactBatchSend,
  SyncExtContact: SyncExtContact,
  GetExtContactEventTimelineList: GetExtContactEventTimelineList,
  AddExtContactEvent: AddExtContactEvent,
  DelExtContactEvent: DelExtContactEvent,
  GetExtContactBatchSendStaffList: GetExtContactBatchSendStaffList,
  GetExtContactBatchSendExtList: GetExtContactBatchSendExtList,
  SetExtContactBatchSend: SetExtContactBatchSend,
  NotifyStaffExtContactBatchSend: NotifyStaffExtContactBatchSend,
  GetWxAdminLoginQrUrl: GetWxAdminLoginQrUrl,
  GetWxAdminLoginState: GetWxAdminLoginState,
  GetDeptList: GetDeptList,
  GetDeptUserList: GetDeptUserList,
  SetCorpVisibleScope: SetCorpVisibleScope,
  GetGroupChatList: GetGroupChatList,
  ExportGroupChatList: ExportGroupChatList,
  GetGroupChat: GetGroupChat,
  GetExtContactGroupChatList: GetExtContactGroupChatList,
  SetExtContactEvent: SetExtContactEvent,
  SyncGroupChat: SyncGroupChat,
  GetGroupChatOwnerList: GetGroupChatOwnerList,
  AddChannel: AddChannel,
  SetChannel: SetChannel,
  GetChannelList: GetChannelList,
  GetChannel: GetChannel,
  AddChannelLiveCode: AddChannelLiveCode,
  SetChannelLiveCode: SetChannelLiveCode,
  BatchSetWelcomeMsg4ChannelLiveCode: BatchSetWelcomeMsg4ChannelLiveCode,
  CountBatchSetWelcomeMsg4ChannelLiveCode: CountBatchSetWelcomeMsg4ChannelLiveCode,
  DelChannelLiveCode: DelChannelLiveCode,
  GetChannelLiveCodeList: GetChannelLiveCodeList,
  CheckExcel4ChannelLiveCode: CheckExcel4ChannelLiveCode,
  ImportChannelLiveCode: ImportChannelLiveCode,
  GetChannelLiveCode: GetChannelLiveCode,
  GetExtContactBatchSendGroupList: GetExtContactBatchSendGroupList,
  AddInviteGroupByTag: AddInviteGroupByTag,
  DelInviteGroupByTag: DelInviteGroupByTag,
  GetInviteGroupByTag: GetInviteGroupByTag,
  GetInviteGroupByTagList: GetInviteGroupByTagList,
  GetAuthRegisterQr: GetAuthRegisterQr,
  CheckAuthRegisterQr: CheckAuthRegisterQr,
  CancelExtContactBatchSend: CancelExtContactBatchSend,
  GetSysUserAttrDef: GetSysUserAttrDef,
  GetSysUserAttrDefList: GetSysUserAttrDefList,
  AddSysUserAttrDef: AddSysUserAttrDef,
  SetSysUserAttrDef: SetSysUserAttrDef,
  DelSysUserAttrDef: DelSysUserAttrDef,
  DownloadResource: DownloadResource,
  CheckInstallStep: CheckInstallStep,
  AddApplyInstall: AddApplyInstall,
  GetApplyInstallAdmin: GetApplyInstallAdmin,
  GetApplyInstallListAdmin: GetApplyInstallListAdmin,
  SetApplyInstallAdmin: SetApplyInstallAdmin,
  CountInviteGroupByTag: CountInviteGroupByTag,
  InitNonAuthApp: InitNonAuthApp,
  SetSystemConfig: SetSystemConfig,
  GetSystemConfig: GetSystemConfig,
  GetWelcomeMsg: GetWelcomeMsg,
  SetWelcomeMsg: SetWelcomeMsg,
  AddWelcomeMsg: AddWelcomeMsg,
  GetWelcomeMsgList: GetWelcomeMsgList,
  DelWelcomeMsg: DelWelcomeMsg,
  GetInstallConfig: GetInstallConfig,
  SetInstallConfig: SetInstallConfig,
  GetWebLoginInfo: GetWebLoginInfo,
  WebLogin: WebLogin,
  AddUserFeedback: AddUserFeedback,
  GetUserFeedbackList: GetUserFeedbackList,
  GetAsyncTaskState: GetAsyncTaskState,
  GetHelpDocList: GetHelpDocList,
  SetCorpTag2Follow: SetCorpTag2Follow,
  AddHelpDoc: AddHelpDoc,
  SetHelpDoc: SetHelpDoc,
  DelHelpDoc: DelHelpDoc,
  AddChangeLog: AddChangeLog,
  DelChangeLog: DelChangeLog,
  SetChangeLog: SetChangeLog,
  GetChangeLogList: GetChangeLogList,
  GetGuidePic: GetGuidePic,
  GetCorpInfo: GetCorpInfo,
  GetHelpDocListStaff: GetHelpDocListStaff,
  GetChangeLogListStaff: GetChangeLogListStaff,
  GetCorpStat: GetCorpStat,
  SendVerifyCode: SendVerifyCode,
  ExportExtContactFollowList: ExportExtContactFollowList,
  GetAuditConfig: GetAuditConfig,
  SetAuditConfig: SetAuditConfig,
  GetContactUsConfig: GetContactUsConfig,
  SetContactUsConfig: SetContactUsConfig,
  GetCommonlyUsedModuleConfig: GetCommonlyUsedModuleConfig,
  SetCommonlyUsedModuleConfig: SetCommonlyUsedModuleConfig,
  GetWxAdminAuthBizCorpIdList: GetWxAdminAuthBizCorpIdList,
  AddCustomizedCustomerClue: AddCustomizedCustomerClue,
  GetCustomizedCustomerClueList: GetCustomizedCustomerClueList,
  UpdateCustomizedCustomerClue: UpdateCustomizedCustomerClue,
  GetCommonlyUsedModuleConfigStaff: GetCommonlyUsedModuleConfigStaff,
  InitAutoInstallApp: InitAutoInstallApp,
  StaffLoginBySsoCode: StaffLoginBySsoCode,
  GetCorpApplyAuditConfig: GetCorpApplyAuditConfig,
  SetCorpApplyAuditConfig: SetCorpApplyAuditConfig,
  GetUserInfo: GetUserInfo,
  SyncDataAfterConfigWwApp: SyncDataAfterConfigWwApp,
  GetJsConfig: GetJsConfig,
  SetOfficialAccountConfig: SetOfficialAccountConfig,
  GetOfficialAccountConfig: GetOfficialAccountConfig,
  GetApplyInstall: GetApplyInstall,
  GetDeptAndUserList: GetDeptAndUserList,
  GetDeptAndUserListState: GetDeptAndUserListState,
  AddMaterialCategory: AddMaterialCategory,
  AddMaterial: AddMaterial,
  SetMaterial: SetMaterial,
  GetMaterial: GetMaterial,
  GetMaterialList: GetMaterialList,
  DelMaterial: DelMaterial,
  SetMaterialCategory: SetMaterialCategory,
  GetMaterialCategoryList: GetMaterialCategoryList,
  DelMaterialCategory: DelMaterialCategory,
  SortMaterialCategory: SortMaterialCategory,
  StaffLoginAsCorpCreator: StaffLoginAsCorpCreator,
  GetCorpListStaff: GetCorpListStaff,
  GetMyAppList: GetMyAppList,
  GetAppList: GetAppList,
  GetAppListStaff: GetAppListStaff,
  GetChannelStat: GetChannelStat,
  GetExtContactDetailStat: GetExtContactDetailStat,
  AddApp: AddApp,
  CreateOrder: CreateOrder,
  PayOrder: PayOrder,
  GetOrderList: GetOrderList,
  GetOrderListStaff: GetOrderListStaff,
  CancelOrder: CancelOrder,
  SetAppStaff: SetAppStaff,
  AddInvoice: AddInvoice,
  BatchDelMaterial: BatchDelMaterial,
  GetInvoice: GetInvoice,
  SetInvoice: SetInvoice,
  GetInvoiceList: GetInvoiceList,
  GetInvoiceListStaff: GetInvoiceListStaff,
  SetInvoiceStaff: SetInvoiceStaff,
  GetInvoiceStaff: GetInvoiceStaff,
  BatchMoveMaterial: BatchMoveMaterial,
  GetSidebarTabListAdmin: GetSidebarTabListAdmin,
  SetSidebarTabOnOffAdmin: SetSidebarTabOnOffAdmin,
  GetSidebarTabList: GetSidebarTabList,
  AddSpeechcraft: AddSpeechcraft,
  GetSpeechcraftList: GetSpeechcraftList,
  SetSpeechcraft: SetSpeechcraft,
  GetSpeechcraft: GetSpeechcraft,
  DelSpeechcraft: DelSpeechcraft,
  AddSpeechcraftCategory: AddSpeechcraftCategory,
  GetSpeechcraftCategoryList: GetSpeechcraftCategoryList,
  DelSpeechcraftCategory: DelSpeechcraftCategory,
  SetSpeechcraftCategory: SetSpeechcraftCategory,
  BatchDelSpeechcraft: BatchDelSpeechcraft,
  BatchMoveSpeechcraft: BatchMoveSpeechcraft,
  SortSpeechcraftCategory: SortSpeechcraftCategory,
  GetSidebarTab: GetSidebarTab,
  GetApp: GetApp,
  UpdateExtContactRemark: UpdateExtContactRemark,
  DelApp: DelApp,
  GetBiLinSsoUrl: GetBiLinSsoUrl,
  CalculatePrice: CalculatePrice,
  GetOrder: GetOrder,
  SyncUser: SyncUser,
  SortSpeechcraft: SortSpeechcraft,
  GetVersionConfig: GetVersionConfig,
  SetVersionConfig: SetVersionConfig,
  ExportChannelStatList: ExportChannelStatList,
  CountExtContact: CountExtContact,
  GetExtContactList: GetExtContactList,
  GetOrderStaff: GetOrderStaff,
  GetVersionFreeDay: GetVersionFreeDay,
  SetVersionFreeDay: SetVersionFreeDay,
  GetVersionConfigList: GetVersionConfigList,
  Login4Audit: Login4Audit,
  GetExtContactWithFollow: GetExtContactWithFollow,
  ExperienceQuan: ExperienceQuan,
  CalcVersionPrice: CalcVersionPrice,
  SyncResignedStaffExtContact: SyncResignedStaffExtContact,
  GetCorpVersionList: GetCorpVersionList,
  ExportCorpVersionList: ExportCorpVersionList,
  GetResignedStaffList: GetResignedStaffList,
  GetResignedStaff: GetResignedStaff,
  GetResignedStaffExtContactList: GetResignedStaffExtContactList,
  GetResignedStaffGroupChatList: GetResignedStaffGroupChatList,
  TransferResignedStaffGroupChat: TransferResignedStaffGroupChat,
  TransferResignedStaffExtContact: TransferResignedStaffExtContact,
  GetCorpVersion: GetCorpVersion,
  GetCorpVersionStaff: GetCorpVersionStaff,
  BatchDeleteUserDistribute: BatchDeleteUserDistribute,
  BatchAddUserDistribute: BatchAddUserDistribute,
  TransferExtContactAndGroupChat2Staff: TransferExtContactAndGroupChat2Staff,
  UpdateCorpVersionStaff: UpdateCorpVersionStaff,
  AddFeatureFlagConfigStaff: AddFeatureFlagConfigStaff,
  DelFeatureFlagConfigStaff: DelFeatureFlagConfigStaff,
  SetFeatureFlagConfigStaff: SetFeatureFlagConfigStaff,
  GetFeatureFlagConfigStaff: GetFeatureFlagConfigStaff,
  GetFeatureFlagConfigListStaff: GetFeatureFlagConfigListStaff,
  GetFeatureFlagEnabled: GetFeatureFlagEnabled,
  BatchAddSpeechcraftKeyword: BatchAddSpeechcraftKeyword,
  DelSpeechcraftKeyword: DelSpeechcraftKeyword,
  GetSpeechcraftKeywordList: GetSpeechcraftKeywordList,
  GetContactAppAuthConfig: GetContactAppAuthConfig,
  AddWwDept: AddWwDept,
  GetWwAdminLoginQrUrl: GetWwAdminLoginQrUrl,
  GetWwAdminLoginState: GetWwAdminLoginState,
  WwAdminSelectCorp2Login: WwAdminSelectCorp2Login,
  EditableContactApp: EditableContactApp,
  SetRobotStaffProfile: SetRobotStaffProfile,
  GetWwDeptList: GetWwDeptList,
  GetGroupChatListSys: GetGroupChatListSys,
  GetRobotStaffProfile: GetRobotStaffProfile,
  GetRobotStaffList: GetRobotStaffList,
  BatchDelRobotUser: BatchDelRobotUser,
  DelAndTransferRobotStaffAssets: DelAndTransferRobotStaffAssets,
  SetContactAppAuthConfig: SetContactAppAuthConfig,
  UploadMaterial2WwMedia: UploadMaterial2WwMedia,
  GetFeatureFlagMap: GetFeatureFlagMap,
  Login4Install: Login4Install,
  AddMiniProgram: AddMiniProgram,
  DelMiniProgram: DelMiniProgram,
  SetMiniProgram: SetMiniProgram,
  GetMiniProgram: GetMiniProgram,
  GetMiniProgramList: GetMiniProgramList,
  SyncFeatureFlag2ReleaseStaff: SyncFeatureFlag2ReleaseStaff,
  BatchDelSpeechcraftKeyword: BatchDelSpeechcraftKeyword,
  AddMessageAuditorConfig: AddMessageAuditorConfig,
  DelMessageAuditorConfig: DelMessageAuditorConfig,
  SetMessageAuditorConfig: SetMessageAuditorConfig,
  GetMessageAuditorConfig: GetMessageAuditorConfig,
  GetMessageAuditorConfigList: GetMessageAuditorConfigList,
  SetMessageAuditSwitch: SetMessageAuditSwitch,
  GetMessageAuditSwitch: GetMessageAuditSwitch,
  BatchApproveMessageAudit: BatchApproveMessageAudit,
  BatchRejectMessageAudit: BatchRejectMessageAudit,
  GetMessageAudit: GetMessageAudit,
  GetMessageAuditList: GetMessageAuditList,
  GetMessageAuditByTaskId: GetMessageAuditByTaskId,
  SendNotify2AuditorList: SendNotify2AuditorList,
  GetCorpByWwInnerCorpId: GetCorpByWwInnerCorpId,
  SetUserRobots: SetUserRobots,
  GetUserRobots: GetUserRobots,
  BatchAddUserRobots: BatchAddUserRobots,
  AddRole: AddRole,
  UpdateRole: UpdateRole,
  DelRole: DelRole,
  CopyRole: CopyRole,
  SortRole: SortRole,
  GetRoleList: GetRoleList,
  GetPermission: GetPermission,
  AddPermission: AddPermission,
  SetPermission: SetPermission,
  GetPermissionList: GetPermissionList,
  DelPermission: DelPermission,
  SetRoleStaff: SetRoleStaff,
  GetDefaultRoleList: GetDefaultRoleList,
  TransferCreator: TransferCreator,
  UpdateApiList: UpdateApiList,
  SetUserRole: SetUserRole,
  GetWechatAuthUrl: GetWechatAuthUrl,
  BatchSetCorpTag2Group: BatchSetCorpTag2Group,
  GetRoleListByUidSys: GetRoleListByUidSys,
  WechatAuthorized: WechatAuthorized,
  SubmitAudit: SubmitAudit,
  GetWechatList: GetWechatList,
  GetCategoryChannelLiveCode: GetCategoryChannelLiveCode,
  LoginWechatByCode: LoginWechatByCode,
  BatchSetCorpTag2AllFollow: BatchSetCorpTag2AllFollow,
  CheckTaggingState: CheckTaggingState,
  PreviewLiveCodeWithUserHeadPic: PreviewLiveCodeWithUserHeadPic,
  AddPayConfig: AddPayConfig,
  DelPayConfig: DelPayConfig,
  SetPayConfig: SetPayConfig,
  GetPayConfigList: GetPayConfigList,
  BatchAddMaterial: BatchAddMaterial,
  AuthorizerBindMch: AuthorizerBindMch,
  GetWechatUserSys: GetWechatUserSys,
  RegisterByPhone: RegisterByPhone,
  LoginByPhone: LoginByPhone,
  GetAccountInfo: GetAccountInfo,
  GetBaseAccountInfo: GetBaseAccountInfo,
  UnbindAccountCorp: UnbindAccountCorp,
  LoginAsCorp: LoginAsCorp,
  GetAccountSid: GetAccountSid,
  GetWxAdminLoginQrUrlV2: GetWxAdminLoginQrUrlV2,
  GetWxAdminLoginStateV2: GetWxAdminLoginStateV2,
  GetInstallData: GetInstallData,
  GetAdvanceExtContactList: GetAdvanceExtContactList,
  GetAdvanceExtContactResult: GetAdvanceExtContactResult,
  CheckMemberInGroup: CheckMemberInGroup,
  SyncCorpDept: SyncCorpDept,
  GetCorpDeptList: GetCorpDeptList,
  AddMenu: AddMenu,
  SetMenu: SetMenu,
  DelMenu: DelMenu,
  GetMenuList: GetMenuList,
  GetUserList4Role: GetUserList4Role,
  GetRole: GetRole,
  SetMenuTemplateConfig: SetMenuTemplateConfig,
  GetMenuTemplateConfig: GetMenuTemplateConfig,
  SwapMenu: SwapMenu,
  GetGroupChatWithoutMember: GetGroupChatWithoutMember,
  GetAccountList: GetAccountList,
  GetTmpAccountSid: GetTmpAccountSid,
  GetSimpleUserList: GetSimpleUserList,
  ExportCorpTag: ExportCorpTag,
  ImportExtContactFollow: ImportExtContactFollow,
  GetImportRecordList: GetImportRecordList,
  GetChannelImportRecordList: GetChannelImportRecordList,
  AddImportRecord: AddImportRecord,
  UpdateImportRecord: UpdateImportRecord,
  CheckExcel4ExtContactFollow: CheckExcel4ExtContactFollow,
  SyncExtContactV2: SyncExtContactV2,
  RecvSyncExtContactMqMsg: RecvSyncExtContactMqMsg,
  GetNotifyConfigList: GetNotifyConfigList,
  SetNotifyConfig: SetNotifyConfig,
  GetCorpGroupNumConfig: GetCorpGroupNumConfig,
  AddCorpGroupNumConfig: AddCorpGroupNumConfig,
  UpdateCorpGroupNumConfig: UpdateCorpGroupNumConfig,
  DelCorpGroupNumConfig: DelCorpGroupNumConfig,
  GetDupExtContactFollowListV2: GetDupExtContactFollowListV2,
  AddExtContactTransferCustomerTask: AddExtContactTransferCustomerTask,
  GetExtContactTransferCustomerRecordList: GetExtContactTransferCustomerRecordList,
  GetAvailableAccountType: GetAvailableAccountType,
  AddChannelLiveCode4BatchSingle: AddChannelLiveCode4BatchSingle,
  BatchDelChannelLiveCode: BatchDelChannelLiveCode,
  BatchDelAllChannelLiveCode: BatchDelAllChannelLiveCode,
  BatchDownloadChannelLiveCode: BatchDownloadChannelLiveCode,
  GetExtContactFollowListPAccount: GetExtContactFollowListPAccount,
  GetMaterialYcPagePathList: GetMaterialYcPagePathList,
  GetExtContactIdList: GetExtContactIdList,
  GetAdvanceExtContactResultAsync: GetAdvanceExtContactResultAsync,
  SetNonAuthAppConfig4Install: SetNonAuthAppConfig4Install,
  SetMaterialYcPagePath: SetMaterialYcPagePath,
  DelMaterialYcPagePath: DelMaterialYcPagePath,
  GetMiniProgramPagePathList: GetMiniProgramPagePathList,
  AddMiniProgramPagePath: AddMiniProgramPagePath,
  SetMiniProgramPagePath: SetMiniProgramPagePath,
  DelMiniProgramPagePath: DelMiniProgramPagePath,
  CreateDeDupChannelLiveCode: CreateDeDupChannelLiveCode,
  SetDeDupChannelLiveCode: SetDeDupChannelLiveCode,
  BatchDelDeDupChannelLiveCode: BatchDelDeDupChannelLiveCode,
  GetDeDupChannelLiveCodeList: GetDeDupChannelLiveCodeList,
  GetDeDupChannelLiveCodeByOpenId: GetDeDupChannelLiveCodeByOpenId,
  CheckExtContactInCorp: CheckExtContactInCorp,
  GetDeDupChannelLiveCode: GetDeDupChannelLiveCode,
  BatchDownloadDeDupChannelLiveCode: BatchDownloadDeDupChannelLiveCode,
  GetCombinedBusinessApp: GetCombinedBusinessApp,
  AddCombinedBusinessApp: AddCombinedBusinessApp,
  GetCombinedBusinessAppList: GetCombinedBusinessAppList,
  UpdateCombinedBusinessApp: UpdateCombinedBusinessApp,
  DelCombinedBusinessApp: DelCombinedBusinessApp,
  CombinedBusinessUserAuth: CombinedBusinessUserAuth,
  GetExtContactFollowField: GetExtContactFollowField,
  ExportBatchSetWelcomeMsg4ChannelLiveCode: ExportBatchSetWelcomeMsg4ChannelLiveCode,
  SyncContactsV2: SyncContactsV2,
  BatchDownloadAllChannelLiveCode: BatchDownloadAllChannelLiveCode,
  RetryBatchSetWelcomeMsg4ChannelLiveCode: RetryBatchSetWelcomeMsg4ChannelLiveCode,
  SendVerifyCodeForBindPhoneNumber: SendVerifyCodeForBindPhoneNumber,
  BindPhoneNumber: BindPhoneNumber,
  GetAccountRegSourceList: GetAccountRegSourceList,
  VerifyCode4BindPhoneNumber: VerifyCode4BindPhoneNumber,
  GetAdvanceExtContactResultAsyncV2: GetAdvanceExtContactResultAsyncV2,
  GetUserBindingPhone: GetUserBindingPhone,
  GetCorpDeptMap: GetCorpDeptMap,
  GetUserDeptList: GetUserDeptList,
  GetExtContactListV2: GetExtContactListV2,
  GenSpeechcraftShareCode: GenSpeechcraftShareCode,
  RefreshSpeechcraftShareCode: RefreshSpeechcraftShareCode,
  ImportSpeechcraftShareCode: ImportSpeechcraftShareCode,
  BatchAddSameTitleSpeechcraft: BatchAddSameTitleSpeechcraft,
  GetExtContactFollowListV2: GetExtContactFollowListV2,
  GetBaseUserInfo: GetBaseUserInfo,
  SetAccountDefaultCorp: SetAccountDefaultCorp,
  CancelSpeechcraftShareCode: CancelSpeechcraftShareCode,
  GetSpeechcraftShareCodeList: GetSpeechcraftShareCodeList,
  GetExtContactListKeyWithFilterAsync: GetExtContactListKeyWithFilterAsync,
  GetExtContactListWithCacheKey: GetExtContactListWithCacheKey,
  GetPersonalSpeechcraftList: GetPersonalSpeechcraftList,
  OrderSpeechcraft: OrderSpeechcraft,
  ValidateAccount: ValidateAccount,
  ModifyAccountPassword: ModifyAccountPassword,
  ModifyAccountPhone: ModifyAccountPhone,
  GetPlatNoticeList: GetPlatNoticeList,
  GetPlatNoticeContent: GetPlatNoticeContent,
  ReadPlatNotice: ReadPlatNotice,
  NoticeRedPoint: NoticeRedPoint,
  GetLatestPlatNotice: GetLatestPlatNotice,
  BatchSetSameTitleSpeechcraft: BatchSetSameTitleSpeechcraft,
  AccountBindUser: AccountBindUser,
  AccountAuthApp: AccountAuthApp,
  UploadSpeechcraftFileContent2WwMedia: UploadSpeechcraftFileContent2WwMedia,
  GetCorpStatV2: GetCorpStatV2,
  UnbindAccountCorpV2: UnbindAccountCorpV2,
  GetAppScope: GetAppScope,
  GetSpeechcraftShareCode: GetSpeechcraftShareCode,
  UpdateSpeechcraftTitleViewOrder: UpdateSpeechcraftTitleViewOrder,
  GetSpeechcraftTitle: GetSpeechcraftTitle,
  SetAdvertConfig: SetAdvertConfig,
  GetAdvertConfig: GetAdvertConfig,
  GetRoleAllowDeptAndMemberList: GetRoleAllowDeptAndMemberList,
  SyncResignedStaffExtContactTransferResult: SyncResignedStaffExtContactTransferResult,
  StaffLoginQuanV2AsCorpCreator: StaffLoginQuanV2AsCorpCreator,
  StaffLoginQuanV2: StaffLoginQuanV2,
  DelPermissionByIds: DelPermissionByIds,
  BatchSetUser4ChannelLiveCode: BatchSetUser4ChannelLiveCode,
  SetCorpAliasName: SetCorpAliasName,
  AddCustomerComplaint: AddCustomerComplaint,
  SyncExtContactPhoneListMq: SyncExtContactPhoneListMq,
  GetAccountListV2: GetAccountListV2,
  SetCorpBaseInfoConfig: SetCorpBaseInfoConfig,
  ExportChannelLiveCodeList: ExportChannelLiveCodeList,
  AddChannelLiveCode4BatchSingleBeExport: AddChannelLiveCode4BatchSingleBeExport,
  HandleAddExtContactCallbackMq: HandleAddExtContactCallbackMq,
  HandleSetExtContactCallbackMq: HandleSetExtContactCallbackMq,
  ExportExtContactBatchSendStaffList: ExportExtContactBatchSendStaffList,
  ExportExtContactBatchSendExtList: ExportExtContactBatchSendExtList,
  BatchReleaseChannelLiveCode: BatchReleaseChannelLiveCode,
  BatchReleaseDeDupChannelLiveCode: BatchReleaseDeDupChannelLiveCode,
  GetGroupChatOwnerCategory: GetGroupChatOwnerCategory,
  BatchSetUser4ChannelLiveCodeV2: BatchSetUser4ChannelLiveCodeV2,
  SyncExtContactByExtUserIdSys: SyncExtContactByExtUserIdSys,
  GetLicenseUserNumber: GetLicenseUserNumber,
  ScheduleHandleCreateAuthForCustomizeApp: ScheduleHandleCreateAuthForCustomizeApp,
  UpdateUserLastShowLicenseAt: UpdateUserLastShowLicenseAt,
  CheckUidList4AuthLicense: CheckUidList4AuthLicense,
  ExportUserList: ExportUserList,
  ImportExcel4BatchUserBindPhoneNumberList: ImportExcel4BatchUserBindPhoneNumberList,
  CheckExcel4ModifyUserBindPhoneNumberList: CheckExcel4ModifyUserBindPhoneNumberList,
  GetRegisterFeatureFlagConfig: GetRegisterFeatureFlagConfig,
  GetCustomizedTplAuthQrCodeV2: GetCustomizedTplAuthQrCodeV2,
  GetNotLoginStyle: GetNotLoginStyle,
  CheckCustomizedAppInstallResult: CheckCustomizedAppInstallResult,
  VerifyUserToBindAccountv2: VerifyUserToBindAccountv2,
  SendExportVerifyCode: SendExportVerifyCode,
  GetAuthUserSensitiveH5Url: GetAuthUserSensitiveH5Url,
  CheckExportVerifyCode: CheckExportVerifyCode,
  GetSysVersionListStaff: GetSysVersionListStaff,
  CreateSysVersionStaff: CreateSysVersionStaff,
  UpdateSysVersionStaff: UpdateSysVersionStaff,
  ToggleSysVersionStateStaff: ToggleSysVersionStateStaff,
  GetSysVersionStaff: GetSysVersionStaff,
  GetChannelLiveCodeForH5: GetChannelLiveCodeForH5,
  WxAppBindBiz: WxAppBindBiz,
  GetWxAppBindBiz: GetWxAppBindBiz,
  GetWxAppBindBizSys: GetWxAppBindBizSys,
  GenerateShortLink: GenerateShortLink,
  GenerateQrcode: GenerateQrcode,
  AddWxAppWebviewDomain: AddWxAppWebviewDomain,
  UpdateWechatUserInfoWx: UpdateWechatUserInfoWx,
  SortSysVersion: SortSysVersion,
  IsMpVersionOnline: IsMpVersionOnline,
  UpdateWxUserMobile: UpdateWxUserMobile,
  GetWatermarkSetting: GetWatermarkSetting,
  SetWatermarkSetting: SetWatermarkSetting,
  BatchUpdateMaterialCategory: BatchUpdateMaterialCategory,
  GetMaterialCategoryPerm: GetMaterialCategoryPerm,
  SchedTrySyncCorpTrialTime: SchedTrySyncCorpTrialTime,
  BatchSetDeDupChannelLiveCode: BatchSetDeDupChannelLiveCode,
  GetFeatByWxApp: GetFeatByWxApp,
  GetCorpRegionConfigListStaff: GetCorpRegionConfigListStaff,
  SetCorpRegionConfigStaff: SetCorpRegionConfigStaff,
  GetChannelRegionList: GetChannelRegionList,
  AddNotifyGroup: AddNotifyGroup,
  UpdateNotifyGroup: UpdateNotifyGroup,
  DeleteNotifyGroup: DeleteNotifyGroup,
  GetNotifyGroup: GetNotifyGroup,
  GetNotifyGroupList: GetNotifyGroupList,
  GetNotifyOfficialAccountsQrcode: GetNotifyOfficialAccountsQrcode,
  NotifyOfficialAccountsCallback: NotifyOfficialAccountsCallback,
  NotifyGroupUserBind: NotifyGroupUserBind,
  NotifyGroupUserInfo: NotifyGroupUserInfo,
  NotifyGroupUserUnbind: NotifyGroupUserUnbind,
  SyncLackExtContact: SyncLackExtContact,
  GetNotifyGroupContentList: GetNotifyGroupContentList,
  PauseExtContactBatchSendTask: PauseExtContactBatchSendTask,
  ContinueExtContactBatchSendTask: ContinueExtContactBatchSendTask,
  DelExtContactBatchSendTask: DelExtContactBatchSendTask,
  AbortExtContactBatchSendTask: AbortExtContactBatchSendTask,
  GetExtContactBatchSendTaskChangedLogList: GetExtContactBatchSendTaskChangedLogList,
  SyncExtContactBatchSendTaskResult: SyncExtContactBatchSendTaskResult,
  ExportChannelList: ExportChannelList,
  ImportChannelList: ImportChannelList,
  CheckExcel4ImportChannelList: CheckExcel4ImportChannelList,
  CheckExcel4ImportDeDupLiveCodeList: CheckExcel4ImportDeDupLiveCodeList,
  ImportDeDupLiveCodeList: ImportDeDupLiveCodeList,
  ExportDeDupLiveCodeList: ExportDeDupLiveCodeList,
  GetExtContactBatchSendTaskChangedLog: GetExtContactBatchSendTaskChangedLog,
  GetCorpGroupNumConfigByCorpId: GetCorpGroupNumConfigByCorpId,
  GetCustomizedTplAuthQrCodeStaff: GetCustomizedTplAuthQrCodeStaff,
  GetNormalRobotGroupNumConfigList: GetNormalRobotGroupNumConfigList,
  GetRobotGroupNumConfigList: GetRobotGroupNumConfigList,
  SetRobotGroupNumConfig: SetRobotGroupNumConfig,
  IsAllowSetLiveCode: IsAllowSetLiveCode
};
export default QuanServices;